var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOther1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.72 228.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6a6a6a;\n      }\n\n      .cls-2 {\n        fill: #b7b7b7;\n      }\n\n      .cls-3 {\n        fill: #9d9d9d;\n      }\n\n      .cls-4 {\n        fill: #a7a7a7;\n      }\n\n      .cls-5 {\n        fill: #797979;\n      }\n\n      .cls-6 {\n        fill: #939393;\n      }\n\n      .cls-7 {\n        fill: #ddd;\n      }\n\n      .cls-8 {\n        fill: #f0f0f0;\n      }\n\n      .cls-9 {\n        fill: #6c6c6c;\n      }\n\n      .cls-10 {\n        fill: #555;\n      }\n\n      .cls-11 {\n        fill: #0f0f0f;\n      }\n\n      .cls-12 {\n        fill: #8b8b8b;\n      }\n\n      .cls-13 {\n        fill: #090909;\n      }\n\n      .cls-14 {\n        fill: #c5c5c5;\n      }\n\n      .cls-15 {\n        stroke: #4e4e4e;\n      }\n\n      .cls-15, .cls-16 {\n        fill: #4e4e4e;\n      }\n\n      .cls-15, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23 {\n        stroke-width: .09px;\n      }\n\n      .cls-24 {\n        fill: #cbcbcb;\n      }\n\n      .cls-25, .cls-21 {\n        fill: #727272;\n      }\n\n      .cls-26 {\n        fill: #575757;\n      }\n\n      .cls-27 {\n        fill: #4c4c4c;\n      }\n\n      .cls-28 {\n        fill: #d1d1d1;\n      }\n\n      .cls-29 {\n        fill: #fafafa;\n      }\n\n      .cls-30 {\n        fill: #848484;\n      }\n\n      .cls-31 {\n        fill: #3f3f3f;\n      }\n\n      .cls-32 {\n        fill: #cacaca;\n      }\n\n      .cls-33 {\n        fill: #d8d8d8;\n      }\n\n      .cls-34 {\n        fill: #f6f6f6;\n      }\n\n      .cls-35 {\n        fill: #bfbfbf;\n      }\n\n      .cls-36 {\n        fill: #9c9c9c;\n      }\n\n      .cls-37 {\n        fill: #aeaeae;\n      }\n\n      .cls-38 {\n        fill: silver;\n      }\n\n      .cls-39 {\n        fill: #989898;\n      }\n\n      .cls-40 {\n        fill: #717171;\n      }\n\n      .cls-41 {\n        fill: #f5f5f5;\n      }\n\n      .cls-42 {\n        fill: #5c5c5c;\n      }\n\n      .cls-43 {\n        fill: #4b4b4b;\n      }\n\n      .cls-44 {\n        fill: #040404;\n      }\n\n      .cls-45 {\n        fill: #777;\n      }\n\n      .cls-46 {\n        fill: #a9a9a9;\n      }\n\n      .cls-47 {\n        fill: #9f9f9f;\n      }\n\n      .cls-48 {\n        fill: #a0a0a0;\n      }\n\n      .cls-49 {\n        fill: #b2b2b2;\n      }\n\n      .cls-50 {\n        fill: #a6a6a6;\n      }\n\n      .cls-51 {\n        fill: #8c8c8c;\n      }\n\n      .cls-52 {\n        fill: #bababa;\n      }\n\n      .cls-53 {\n        fill: #959595;\n      }\n\n      .cls-54 {\n        fill: #020202;\n      }\n\n      .cls-55 {\n        fill: #868686;\n      }\n\n      .cls-56 {\n        fill: #d6d6d6;\n      }\n\n      .cls-57 {\n        fill: #b4b4b4;\n      }\n\n      .cls-58 {\n        fill: #303030;\n      }\n\n      .cls-59 {\n        fill: #c9c9c9;\n      }\n\n      .cls-60 {\n        fill: #393939;\n      }\n\n      .cls-61 {\n        fill: #7c7c7c;\n      }\n\n      .cls-62 {\n        fill: #232323;\n      }\n\n      .cls-63 {\n        fill: #2f2f2f;\n      }\n\n      .cls-64 {\n        fill: #e0e0e0;\n      }\n\n      .cls-65 {\n        fill: #8d8d8d;\n      }\n\n      .cls-17 {\n        fill: #1a1a1a;\n        stroke: #1a1a1a;\n      }\n\n      .cls-66 {\n        fill: #656565;\n      }\n\n      .cls-67 {\n        fill: #c7c7c7;\n      }\n\n      .cls-68 {\n        fill: #a4a4a4;\n      }\n\n      .cls-69 {\n        fill: #dedede;\n      }\n\n      .cls-70 {\n        fill: #6b6b6b;\n      }\n\n      .cls-71 {\n        fill: #696969;\n      }\n\n      .cls-72 {\n        fill: #c3c3c3;\n      }\n\n      .cls-73 {\n        fill: #cfcfcf;\n      }\n\n      .cls-74 {\n        fill: #d7d7d7;\n      }\n\n      .cls-75 {\n        fill: #bdbdbd;\n      }\n\n      .cls-76 {\n        fill: #313131;\n      }\n\n      .cls-77 {\n        fill: #1b1b1b;\n      }\n\n      .cls-78 {\n        fill: #707070;\n      }\n\n      .cls-79 {\n        fill: #111;\n      }\n\n      .cls-80 {\n        fill: #818181;\n      }\n\n      .cls-81 {\n        fill: #e1e1e1;\n      }\n\n      .cls-82 {\n        fill: #929292;\n      }\n\n      .cls-83 {\n        fill: #969696;\n      }\n\n      .cls-84 {\n        fill: #101010;\n      }\n\n      .cls-85 {\n        fill: #626262;\n      }\n\n      .cls-86 {\n        fill: #b0b0b0;\n      }\n\n      .cls-87 {\n        fill: gray;\n      }\n\n      .cls-88 {\n        fill: #5a5a5a;\n      }\n\n      .cls-89 {\n        fill: #d4d4d4;\n      }\n\n      .cls-90 {\n        fill: #242424;\n      }\n\n      .cls-91 {\n        fill: #828282;\n      }\n\n      .cls-92 {\n        fill: #8f8f8f;\n      }\n\n      .cls-93 {\n        fill: #787878;\n      }\n\n      .cls-94 {\n        fill: #767676;\n      }\n\n      .cls-95 {\n        fill: #dadada;\n      }\n\n      .cls-96 {\n        fill: #8e8e8e;\n      }\n\n      .cls-97 {\n        fill: #b8b8b8;\n      }\n\n      .cls-98 {\n        fill: #898989;\n      }\n\n      .cls-99 {\n        fill: #eaeaea;\n      }\n\n      .cls-100 {\n        fill: #a1a1a1;\n      }\n\n      .cls-101 {\n        fill: #747474;\n      }\n\n      .cls-102 {\n        fill: #414141;\n      }\n\n      .cls-103, .cls-20 {\n        fill: #676767;\n      }\n\n      .cls-104 {\n        fill: #c8c8c8;\n      }\n\n      .cls-105 {\n        fill: #f1f2f2;\n      }\n\n      .cls-106 {\n        fill: #fdfdfd;\n      }\n\n      .cls-107 {\n        fill: #e4e4e4;\n      }\n\n      .cls-108 {\n        fill: #737373;\n      }\n\n      .cls-109 {\n        fill: #a3a3a3;\n      }\n\n      .cls-110 {\n        fill: #f9f9f9;\n      }\n\n      .cls-111 {\n        fill: #464646;\n      }\n\n      .cls-18 {\n        fill: #58595b;\n      }\n\n      .cls-18, .cls-19, .cls-22 {\n        stroke: #010101;\n      }\n\n      .cls-19 {\n        fill: #a7a9ac;\n      }\n\n      .cls-112 {\n        fill: #b6b6b6;\n      }\n\n      .cls-20 {\n        stroke: #676767;\n      }\n\n      .cls-113 {\n        fill: #878787;\n      }\n\n      .cls-114 {\n        fill: #616161;\n      }\n\n      .cls-115 {\n        fill: #afafaf;\n      }\n\n      .cls-116 {\n        fill: #494949;\n      }\n\n      .cls-117 {\n        fill: #d3d3d3;\n      }\n\n      .cls-118 {\n        fill: #ebebeb;\n      }\n\n      .cls-119 {\n        fill: #bebebe;\n      }\n\n      .cls-120 {\n        fill: #adadad;\n      }\n\n      .cls-121 {\n        fill: #d5d5d5;\n      }\n\n      .cls-122 {\n        fill: #2e2e2e;\n      }\n\n      .cls-123 {\n        fill: #373737;\n      }\n\n      .cls-124 {\n        fill: #dcdcdc;\n      }\n\n      .cls-125 {\n        fill: #636363;\n      }\n\n      .cls-126 {\n        fill: #353535;\n      }\n\n      .cls-127 {\n        fill: #c1c1c1;\n      }\n\n      .cls-128 {\n        fill: #161616;\n      }\n\n      .cls-129 {\n        fill: #474747;\n      }\n\n      .cls-130 {\n        fill: #141414;\n      }\n\n      .cls-131 {\n        fill: #999;\n      }\n\n      .cls-132 {\n        fill: #bcbcbc;\n      }\n\n      .cls-133 {\n        fill: #515151;\n      }\n\n      .cls-134 {\n        fill: #9b9b9b;\n      }\n\n      .cls-135 {\n        fill: #ccc;\n      }\n\n      .cls-136 {\n        fill: #ababab;\n      }\n\n      .cls-137 {\n        fill: #757575;\n      }\n\n      .cls-138 {\n        fill: #0b0b0b;\n      }\n\n      .cls-139 {\n        fill: #252525;\n      }\n\n      .cls-140 {\n        fill: #f7f7f7;\n      }\n\n      .cls-141 {\n        fill: #b3b3b3;\n      }\n\n      .cls-142 {\n        fill: #efefef;\n      }\n\n      .cls-143 {\n        fill: #434343;\n      }\n\n      .cls-144 {\n        fill: #9a9a9a;\n      }\n\n      .cls-21 {\n        stroke: #727272;\n      }\n\n      .cls-145 {\n        fill: #545454;\n      }\n\n      .cls-146 {\n        fill: #7b7b7b;\n      }\n\n      .cls-147 {\n        fill: #525252;\n      }\n\n      .cls-148 {\n        fill: #454545;\n      }\n\n      .cls-149 {\n        fill: #a8a8a8;\n      }\n\n      .cls-150 {\n        fill: #949494;\n      }\n\n      .cls-22 {\n        fill: #808285;\n      }\n\n      .cls-151 {\n        fill: #cecece;\n      }\n\n      .cls-152 {\n        fill: #f3f3f3;\n      }\n\n      .cls-153 {\n        fill: #070707;\n      }\n\n      .cls-154 {\n        fill: #acacac;\n      }\n\n      .cls-155 {\n        fill: #b5b5b5;\n      }\n\n      .cls-156 {\n        fill: #484848;\n      }\n\n      .cls-157 {\n        fill: #7f7f7f;\n      }\n\n      .cls-158 {\n        fill: #8a8a8a;\n      }\n\n      .cls-159 {\n        fill: #d9d9d9;\n      }\n\n      .cls-160 {\n        fill: #6d6d6d;\n      }\n\n      .cls-161 {\n        fill: #595959;\n      }\n\n      .cls-162 {\n        fill: #6e6e6e;\n      }\n\n      .cls-163 {\n        fill: #cdcdcd;\n      }\n\n      .cls-164 {\n        fill: #5b5b5b;\n      }\n\n      .cls-165 {\n        fill: #f8f8f8;\n      }\n\n      .cls-166 {\n        fill: #d2d2d2;\n      }\n\n      .cls-167 {\n        fill: #404040;\n      }\n\n      .cls-168 {\n        fill: #9e9e9e;\n      }\n\n      .cls-169 {\n        fill: #c6c6c6;\n      }\n\n      .cls-170 {\n        fill: #eee;\n      }\n\n      .cls-171 {\n        fill: #838383;\n      }\n\n      .cls-172 {\n        fill: #686868;\n      }\n\n      .cls-173 {\n        fill: #1e1e1e;\n      }\n\n      .cls-174 {\n        fill: #d0d0d0;\n      }\n\n      .cls-175 {\n        fill: #ececec;\n      }\n\n      .cls-176 {\n        fill: #666;\n      }\n\n      .cls-177 {\n        fill: #c4c4c4;\n      }\n\n      .cls-23 {\n        fill: #fff;\n        stroke: #fff;\n      }\n\n      .cls-178 {\n        fill: #010101;\n      }\n\n      .cls-179 {\n        fill: #888;\n      }\n\n      .cls-180 {\n        fill: #a2a2a2;\n      }\n\n      .cls-181 {\n        fill: #b9b9b9;\n      }\n\n      .cls-182 {\n        fill: #fefefe;\n      }\n\n      .cls-183 {\n        fill: #060606;\n      }\n\n      .cls-184 {\n        fill: #fcfcfc;\n      }\n\n      .cls-185 {\n        fill: #dfdfdf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "#000000ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m303.7,174.93c1.01-.05,2.01-.08,3.02-.12-2.67,12.86,6.98,34.14-7.04,40.35-5.69,4.3-10.9,4.32-12.17-3.25,12.79,23.26-.69-25.61-11.2-24.74,9.29-4.06,18.38-8.05,27.4-12.25m-7.19,37.13c-1.48.18-1.3,2.52.2,2.45,1.72.02,1.5-2.74-.2-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m202.34,179.17c8.26,3.59,17.21,6.85,25.78,10.39-6.1,9.62-9.46,20.78-11.71,31.84,2.11-1.63,3.33-4.35,4.3-6.54-2.67,11.36-10.88,5.62-18.37,2.47,0,0,0-38.16,0-38.16m10.68,36.8c-1.41.3-1.13,2.51.31,2.44,1.79-.02,1.42-2.87-.31-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m251.98,187.5c7.74-1.57,15.89,5.37,23.46,2.06,13.11,40.48-7.19,9.22-24.46,5.27-4.87.45-9.06,6.34-13.87,5.01-2.1-2.04,1.46-3.27,2.75-4.39,2.38-5.23,7.37-5.76,12.11-7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m233.84,194.86c.21-2.7,4.37-.14,6.47-1.03-1.23,2.2-6.7,3.47-3.61,6.53,4.7,1.97,9.02-3.99,13.61-4.65,7.86,2.53,23.69,10.51,25.8,18.93-2.3,9.16-11.1-5.97-14.53-3.11,13.93,7.76,5.63,17.42-5.01,5.08-.13,3.02,9.55,5.37,6.24,8.97-4.58,2.65-7.3-4.28-11.54-4.38.96,1.23,10.45,5.7,3.09,6.41-1.11-.15-2-1.94-3.19-1.25-1.84-1.68-2.46-4.51-5.4-4,1.55-2.62-1.34-6.39-4.24-4.82-.56-2.89-4.31-4.05-6.07-1.55-2.03-1.74-4.05-3.52-6.22-1.6.23-6.65,2.42-13.25,4.58-19.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m231.15,216.56c-.16-.84-.07-1.69-.04-2.54,1.79.51,3.15,1.85,4.57,2.98,1.37-3.14,5.25-1.54,5.46,1.48,3.08-2.24,5.9,2.05,3.47,4.53,2.92-.52,4.37,1.7,5.97,3.67-2.28,1.53-4.07.62-5.61-1.23-2.26-1.12-5.39-1.24-4.83-4.67-2.52,2.42-5.43-.33-4.77-3.36-1.25.7-3.63.61-4.2-.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1a1a1aff",
    "data-name": "#1a1a1aff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m306.72,174.81h.05s.08,35.93-.04,35.93c-.03-11.98,0-23.95-.01-35.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_ffffffff",
    "data-name": "#ffffffff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m253.37,186.59c7.16-.38,14.58,5.07,21.59,2.49,8.38-5.89,13.82,15.84,16.75,21.97-6.27-.09-13.17,7.9-11.27-2.62-1.28,1.18-2.53,2.64-4.15,3.43,2.87,5.61-3.53,8.85-7.37,4.34,2.35,3.59-.18,7.95-4.41,7.84-.34.91-.7,1.85-1.62,2.41-2.42,1.65-4.63-1.59-5.98,1.69-3.51,1.73-4.65-1.81-9.37-.04-1.57.18-1.86-1.47-3.02-2.14-1.97-1.02-4.91-1.01-5.07-3.89-2.32,1.22-5.21-1.08-4.77-3.64-2.48.58-4.88-.99-4.29-3.7-1.58,0-.45,1.35-.49,2.27-3.97.53-7.76-2.56-11.96-2.68,2.89-7.11,4.64-21.93,11.78-23.99,1.63.8,3.54.43,5.09,1.33-1.1,2.43,4.01,1.36,5.7,1.47,2.65-4.19,8.37-5,12.85-6.56m-1.39.9c-4.74,2.19-9.74,2.71-12.11,7.95-1.3,1.12-4.85,2.35-2.75,4.39,4.81,1.32,9.01-4.56,13.87-5.01,17.28,3.96,37.57,35.19,24.46-5.27-7.57,3.32-15.72-3.63-23.46-2.06m-18.14,7.37c-2.16,6.27-4.35,12.87-4.58,19.52,2.17-1.92,4.19-.14,6.22,1.6,1.76-2.5,5.52-1.34,6.07,1.55,2.9-1.57,5.79,2.2,4.24,4.82,2.93-.51,3.55,2.32,5.4,4,1.18-.69,2.08,1.1,3.19,1.25,7.36-.71-2.13-5.17-3.09-6.4,4.23.1,6.96,7.03,11.54,4.38,3.3-3.59-6.37-5.95-6.24-8.97,10.63,12.33,18.94,2.68,5.01-5.08,3.43-2.86,12.24,12.28,14.53,3.12-2.09-8.42-17.95-16.4-25.8-18.94-4.6.66-8.92,6.63-13.62,4.66-3.08-3.06,2.4-4.32,3.61-6.53-2.1.9-6.26-1.67-6.47,1.03m-2.69,21.69c.57,1.48,2.94,1.57,4.2.87-.66,3.03,2.25,5.77,4.77,3.36-.55,3.43,2.57,3.54,4.83,4.67,1.53,1.85,3.34,2.76,5.61,1.23-1.6-1.97-3.05-4.19-5.97-3.67,2.43-2.49-.39-6.77-3.47-4.53-.21-3.02-4.08-4.62-5.46-1.48-1.42-1.13-2.77-2.47-4.57-2.98-.02.84-.11,1.7.04,2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_666666ff",
    "data-name": "#666666ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m289.8,211.39c2.71-2,5.13,7.65,2.28,6.91-2.48-.75-6.97-7.12-2.28-6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m296.51,212.18c1.73-.27,1.65,2.57-.07,2.19-1.17-.25-1.11-2.02.07-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m212.97,216.1c1.92-.48,1.83,2.73-.06,2.12-.98-.32-.92-1.84.06-2.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_717171ff",
    "data-name": "#717171ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m296.51,212.06c1.7-.28,1.92,2.47.2,2.45-1.5.07-1.68-2.27-.2-2.45m0,.12c-1.18.17-1.23,1.94-.07,2.19,1.72.38,1.79-2.46.07-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m213.02,215.97c1.73-.43,2.1,2.42.31,2.44-1.44.07-1.72-2.14-.31-2.44m-.05.13c-.97.28-1.04,1.8-.06,2.12,1.89.61,1.97-2.6.06-2.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4d4d4dff",
    "data-name": "#4d4d4dff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m217.95,214.35c.89.15,1.78.28,2.66.49-.76,2.51-2.18,4.86-4.19,6.57.67-2.31,1.03-4.7,1.53-7.06Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m23.33,98.24c8.16-7.16,19.98-8.3,29.11-5,9.4,3.4,14.05,10.82,17.22,15.89,7.78,12.42,7.4,24.26,6.89,40.33-.44,13.79-2.98,17.64-5.67,19.67-3.34,2.51-7.04,2.3-12.67,2.11-30.53-1.04-34.68,1.27-37.89-3-3.44-4.57.83-7.87-1.44-22.56-1.54-9.93-3.76-10.14-4.56-17.56-.47-4.34-2.16-20.1,9-29.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m13.8,218.64c1.59-8.71-.76-14.32-10.93-12.62-3.77,12.32-6.51,19.81,9.87,18.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3,222.63c1.03,1.48-1.05.8-1.37,1.6,15.03-2.92,32.21,2.11,45.95-1.55,2.89-3.47.8-10.72,5.79-12.07,2.82-.33,12.47-1.83,11.31,2.95,10.59,2.67,3.35-20.13,3.93-26.47-1.96-11.87-17.09-9.11-26-10.09,2.64,8.51-30.75,13.51-22.8.91h-.01c-1.36-2.17-5.95.66-8.44.13-2.76,14.1-16.42,30.25-8.34,44.6Zm46.08-31.87c.18-1.78.27-3.56.89-5.63-.91,8.69,1.26,17.75-.02,25.67-3.72-3.23-.77-15.04-.87-20.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96,121.48c-7.77-34.83,43.27-44.13,57.98-16.66,9.31,18.95,11.21,42.4,11.03,63.14-1.91-1.88-.37-4.46-1.22-6.49-2.01,1.36.83,10.21-2.65,11.77-6.38,2.84-13.71,2.02-20.54,2.45-3.14.96-2.52-3.08-3.54-4.87h0c-.37-4.65-1.09-9.47.44-13.75,5.89-4.17,10.17-13.83,9.3-21.26,1.42-1.04.69-3.52,2.78-4.2-1.26.16-1.53-.27-1.42-1.48-1.78-4.85-4.68,4.67-4.41,6.56-.03,2.4-1.51,4.78,1.29,6.17.59.35.28.6.14.89-12.94,29.71-9.46-2.18-5.32-.15-3.52-2.88-1.54-7.04-1.03-10.59-3.2-5.87-9.61-12.57-12.1-20.01-4.17-2.91.86,8.71,2.09,10.01.55,3.21,3.78,3.74,4.6,6.42-3.69-3.08-7.88,1.93-11.13,2.17.02-.61-2.11-.12-.73-1.42,1.43-.86-4.11-2.12-5.33.87-.44-.01-.65.8-1.21.33,3.49-9.42,9.02-2.13,14.18-4.96-2.9-5.29-8.29-6.28-14.1-4.84-5.96-1.99,5.71-3.78,7.7-2.69,1.38.79,1.71.18,1.45-1.12-2.05-22.45-25.62-21.58-27.47.48-.39,1.68.81,1.5,1.88,1.33,1.9.4,5.96,1.19,5.67,3.63-2.5.71-5.48-2.22-8.35-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.64,176.1c-3.48-1.15-16.43.67-17.25-2.81-.49-9.32-.18-11.42-4.06-1.59-.48,1.02-1.96.49-1.45-.47,4.44-7.58.65-18.65,3.22-25.02,2.72,4.65,12.27,26.46,17.12,16.14-.59-3.19,3.62-5.01,6.21-3.21.49.31.72.96,1.54.36,2.37-2.3,1.78,1.38,1.78,2.79-1.27,1.16-2.81.14-4.61.33,1.48,1.09,2.72,1.53,4.11,1.58-1.03,4.02-1.89,12.15-6.61,11.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m38.39,175.83c5.56-18.1,4.8-6.86,15.21-15.44,1.47,3.36-.74,7.35,1.43,10.44h0c.29,1.24-1.07,3.95.98,3.76,9.06,7.91-15.71,13.74-20.47,9.55l.02.02c-.36-2.07-1.34-4.09-.45-6.25h-.01c1.32-.33,2.86-.33,3.3-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.8,207.87c-3.94-2.92-13.58-.54-12.23-3.85,6.72-8.34,8.01-27.89,23.59-25.55-3.29,9.64-7.49,20.3-11.36,29.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m66.89,222.09c9.41-3.11,11.41,3.44,13.08-8.54,1.17-4.78-8.49-3.28-11.3-2.95-4.99,1.36-2.9,8.61-5.79,12.07,1.34-.22,2.67-.41,4.01-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m78.72,221.04c-3.94.11-8.02-.28-11.83,1.06,3.73-1.09,8.75.13,11.83-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m13.8,207.87c4.87-8.65,6.81-22.56,12.85-29.84-2.76,14.09-16.42,30.25-8.34,44.6-.99,4.8-3.41-4.5-4.11-5.8.21-2.99.29-5.58-.39-8.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m30.86,165.05c-8.41-1.91-11.35-13.51-15.19-20.28-2.88-4.65,1.08-9.87.59-14.68.88.06.99.87,1.38,1.41-4.39,12.42,4.44,25.89,13.22,33.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.26,130.08c-.36,1.79.57,3.82-1.01,5.38-1.93-1.6.25-5.48-2.16-5.96-2.11-1.09-2.08-3.47.62-2,.31-.95-.32-2.88,1.05-2.62.55,5.04,11.74-.21,10.34,7.03-.72-.44-1.32-1.09-2.02.3-3.15,3.08-2.42-2.88-4.02-2.53-.94.04-2-.52-2.81.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m18.11,178.98c-10.27,4.58-10.48,17.94-16.55,25.03,1.81-8.02,7.2-23.98,16.55-25.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m38.39,175.83c-.44,1.74-1.98,1.74-3.3,2.08.18-.87.39-2.04,1.47-1.98-.33.5.77.52.45,0,.48.17.93,0,1.38-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m14.77,124.88c-1.76.3-.86-2.37-.81-3.4.69.57.29,2.43.81,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m15.67,144.76c-.11.56.38.94.43,1.45-1,.33-1.37-.96-.43-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m16.86,224.24c.14-.03.12-.26.26-.37-1.32-.91-.83-2.75-1.91-3.78-.69,2.1-.95,3.87,1.64,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m13.91,208.71c.6,1.43.64,2.86-.03,4.28-.19-1.43-.25-2.86.03-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m14.01,213.87c.93.35.99.85.28,1.5-.53-.42-.5-.94-.28-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m65.27,185.13c-.15,8.58-.22,16.19.65,24.56-4.23,6.09-1.64-22.58-.65-24.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m35.1,177.9c-.88,2.16.1,4.18.45,6.25-2.52-2.3-2.63-3.77-.45-6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m35.54,184.13c.24.01.41.12.5.35-.3.08-.42-.11-.5-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m14.77,124.88c-2.48-6.9,4.72-.71,7.54-1.66.29-2.44-3.76-3.23-5.67-3.63,1.65-22.21,22.56-25.4,25.59-1.81.62,3.75-2.66-1.86-9.93,1.73-4.42,4.94,10.93-2.71,14.87,6.91-5.14,2.82-10.71-4.45-14.18,4.96,1.53-.38,2.72.61,4.5.7,4.34,2.36,8.84-6.77,13.9-2.66-.81-2.67-4.05-3.21-4.6-6.42-1.24-1.32-6.25-12.9-2.09-10.01,2.49,7.44,8.9,14.15,12.11,20.01-.51,3.56-2.49,7.71,1.02,10.6-7.72.03,3.82,21.02-15.09,18.69.33-7.17-1.35-.9-3.32-3.16-8.35-3.62-4.06,6.25-8.56,5.9-8.78-7.66-17.61-21.13-13.22-33.55.85.57,1.72.99,2.73.41,1.87,3.39,3-2.04,4.73,0,1.39-7.24-9.78-1.98-10.34-7.03Zm17,22.76c-3.3-.97-11.79-3.68-7.84,2.56-1.41,11.92,20.02-2.69,7.84-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m64.75,137.13c1.87,3.6-5.68,19.47-9.29,19.94l.04.04c2.26-4.56,7.08-9.46,7.51-14.25-2.8-1.39-1.33-3.76-1.29-6.17,1.63-.04.08,2.41,1.59,1.82,1.2.18.16-1.4,1.44-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m24.24,101.82c-3.79,5.11-6.76,11.13-7.6,17.76-5.4.09,2.94-17.63,7.6-17.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m42.74,162.3c5.05,2.33,9.51-3.56,12.76-5.19l-.04-.04c-1.42,6.1-12.15,8.89-17.33,5.56,1.8-.19,3.33.82,4.61-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m53.6,160.38c.17-.38.52-.43.88-.47.21,3.63.09,7.29.56,10.91-2.17-3.09.03-7.08-1.43-10.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m64.77,135.81c-.43-1.88.52-4.76,2.78-4.2-2.09.67-1.37,3.16-2.78,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m37.49,132.08c1.32.07,2.49-.39,3.79-.48-1.29,1.36-2.42,1.51-3.79.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m35.17,118.61c1.89-.39,3.79-.88,5.6.29-1.85-.4-3.74-.05-5.6-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m56.01,174.58c-2.06.19-.7-2.51-.98-3.76.56,1.19.72,2.49.98,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m39.53,130.17c-.06-.17-.13-.34-.19-.51.29-.72.84.33.19.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m26.65,101.33c-.19.2-.39.28-.65.12.19-.19.4-.23.65-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m66.13,130.13c-.24-.11-.28-.3-.21-.53.2.12.41.24.21.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m42.25,164.21c1.34-.77,2.8-.4,4.22-.43-1.13.24-3.66,1.66-4.22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m36.56,175.93c.17-.43.57-.05.49.25-.2-.03-.73.08-.49-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m47.43,163.69c1.41-.65,2.74-1.48,4.27-1.85-.72,2.25-2.61,1.78-4.27,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m36.52,176.16c.18,0,.35.01.53.02-.19.22-.36.21-.53-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m35.61,148.04c-.45,7.2-12.7,9.81-11.68,2.16.15-1.46-1.95-1.99-.84-3.47,3.78-1.71,8.48,1.9,12.53,1.31Zm-2.49,1.28c-2.83.44-5.21.1-7.59.28.6,3.93,5.59,2.23,7.59-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m35.61,148.04c-1.29-.05-2.64.45-3.85-.4,1.28.12,2.64-.44,3.85.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m243.32,156.63h-13.56c-8.3-.14-16.26-2.1-23.77-5.41-25.5-11.23-41.23-30.6-47.19-57.84-.55-2.5-.24-5.11-.7-7.64v-13.82c.31-2.4.25-4.82.53-7.22.05-.45.12-.89.16-1.34,2.01-.78,2.07-2.5,2.09-4.28,0-.66.54-.84,1.11-.82.93.02,1.22.71,1.33,1.46.59,4.02,3.74,6.77,5.17,10.42.77,1.96,3.14,2.51,5.51,2.8,3.1.38,6.04,1.74,7.99,4.49,1.48,2.08,3.16,3.69,6.02,2.84.84-.25,1.42.4,1.63.98.72,2,.5,3.98-.8,5.68-1.06,1.38-1.26,2.77-1.37,4.54-.3,4.69,2.44,8.19,5.37,10.35,4.45,3.29,5.02,7.69,5.69,12.17.89,5.92.62,11.98,2.71,17.76.59,1.63.18,3.61,1.7,4.99.76.69.94,2.6,2.19,2.01,1.17-.56,1.52-2.52,1.08-3.64-.81-2.03-.45-4.05-.47-6.03-.02-1.62,1.8-2.35,3.05-3.21.41-.28,1.33-.49,1.18-.81-2.22-4.96,3.77-3.8,4.89-6.45.58-1.38,1.94-2.52,1.7-4.25-.27-1.94.76-3.09,2.41-3.27,3.86-.42,4.56-3.08,4.43-6.1-.13-3.12,1.64-5.33,3.02-7.76.23-.41.62-.76.44-1.27-.19-.53-.7-.63-1.17-.6-.91.05-1.47-.4-2.03-1.07-2.26-2.68-5.62-1.73-8.48-2.47-1.26-.33-2.48-.77-3.64-1.26-.75-.31-.12-1.36.02-2.09.53-2.79-1.37-4.15-3.43-5.02-3.36-1.43-6.17-4.06-10.01-4.44-.84-.08-1.43-.18-1.69.73-.18.63-.33,1.32-1.11,1.39-.88.08-1.25-.59-1.53-1.29-.14-.34-.49-.78-.71-.53-1.57,1.79-3.4,1.13-5.42,1.15-2.85.03-4.02-.93-4.05-3.48-.02-1.37-.31-2.07-1.73-2.46-1.68-.46-1.48-1.81-.97-3.13.14-.35.33-.74-.05-1.05-.23-.19-.52-.09-.7.09-2.1,2.1-4.52,2.04-6.25-.02-2.03-2.42-1.2-5.41.14-7.94,1.22-2.3,3.37-2.76,6.04-2.85,3.07-.1,6.08-1.3,8.39,1.87.23.32.49-.47.44-.77-.3-2.01.75-2.98,2.52-3.52.93-.28,1.82-.87,2.09-1.77,1.44-4.87,6.1-6.26,9.56-8.91,1.05-.8,2.51-.97,3.93-.61.74.19,1.54.16,2.2-.35.2-.16.14-.43-.05-.56-.76-.53-1.21-1.63-2.44-1.33-.76.19-1.72.59-2.06-.53-.36-1.2.49-1.77,1.48-2.17,2.68-1.09,5.54-.77,8.32-1.06.58-.06,1.32-.13,1.48-.8.17-.68-.64-.68-1.02-.94-.57-.39-.76-.75-.71-1.53.09-1.44.3-3.22-2.12-3.02-.5.04-.88-.24-1.21-.61-2.39-2.68-4.42-2.43-5.69.98-1.17,3.13-4.39,4.01-6.29,6.32-.59.71-1.88.19-1.95-.95-.1-1.67-.92-2.56-2.37-3.11-1.6-.61-2.7-1.63-2.56-3.52.13-1.84,1.63-2.43,2.97-2.98,3.32-1.37,6.07-4.31,10.1-3.77.15.02.48-.07.38-.36-.05-.14-.31-.08-.47-.03-.37.1-.71.33-1.1.33-2.08.02-2.24-2.05-3.36-3.09-.01,1.87-.61,3.29-2.76,3.37-1.66.06-3.61-.6-4.92-.06-4.51,1.87-7.94-1.93-12.04-1.79-.48.02-.68-.45-.94-.79,1.27-2.56,3.66-4.05,5.74-5.79,10.82-9.03,23.14-14.93,37.09-17.2,2.74-.45,5.56-.32,8.33-.59h12.54c8.31.47,16.28,2.35,23.93,5.65,9.45,4.09,17.76,9.83,25.08,17.04.48.48.65,1.08.62,1.74.19,1.06-.32,1.49-1.33,1.7-2.53.51-4.57,2.45-7.3,2.51-.85.02-1.37-.31-1.89-.81-.54-.52-1.26-1.01-.98-1.92.27-.89,1.08-.64,1.73-.69.24-.02.5.1.73-.07-.18-.21-.45-.24-.69-.29-5.66-1.25-10.62-1.76-15.49,3.39-2.98,3.15-5.21,3.63.64,4.64.82.14.97,2.01,2.29,1.21,1.32-.8,1.13-2.04,1.06-3.47-.11-2.43,1.92-3.56,3.86-4.29.95-.35,1.31.63.86,1.49-1.6,3.08.15,3.33,2.56,3.14.88-.07,2.14-.67,2.44.62.29,1.25-1.07,1.29-1.88,1.56-1.99.66-3.38,1.86-4.65,3.6-1.42,1.95-4.21,1.47-6.04,1.29-3.22-.32-5.38,1.01-7.66,2.68-.54.4-1.07,1.26-1.91.4-.09-.19-.35-.34-.33-.53.21-2.09-1.23-3.26-2.48-4.54-.06-.06-.08-.14-.15-.19-.04-.04-.02-.02.05.03.07.04.04.15.07.17,1.13.86.97,1.85.36,2.94-.48.87.11,1.15.83,1.26.62.09,1.31-.02,1.59.76.28.36.18.61-.2.82-.34.19-.71.3-1.06.44-1.39.56-1.49.85-.8,2.18,1.07,2.05.51,3.19-1.78,3.65-.46.09-.93.18-1.4.09-1.04-.19-1.53.27-1.61,1.28-.01.17-.06.34-.09.5-.38,1.79-.08,2.55,1.19,3.06,1.45.59,3.17.08,3.89-1.25.51-.93,1.21-1.64,2.04-2.25.42-.3.89-.59,1.09-1.06.56-1.29,1.68-1.6,2.89-1.76.51-.06,1.03-.11,1.48-.38,1.21-.73,2.19-.33,3.1.57.15.15.33.28.44.46.66,1.06,1.48,1.87,2.77,2.1.25.04.5.2.65.44-.19-.27-.48-.45-.75-.55-1.32-.48-2.25-1.34-2.81-2.61-.19-.43-.35-.89.06-1.28.39-.38.87-.33,1.31-.13,1.47.68,2.89,1.47,4.28,2.3.59.35.93,1.01.99,1.72.1,1.15.93,1.77,1.68,2.46.07.07.13.24.27.11.05-.05,0-.16-.02-.24-.11-.33-.38-.57-.48-.9-.25-.78-.08-1.37.83-1.5.67-.1,1.34-.28,2.03-.28.98,0,1.52-.44,1.58-1.43.08-1.31.79-2.33,1.63-3.25.78-.84,1.58-.97,2.51-.33.63.44,1.04.33,1.57-.11.49-.41,1.06-.71,1.64-.99.47-.23.98-.4,1.45-.05.49.35.56.96.36,1.39-.58,1.27-.09,1.91,1.03,2.52.9.48,1.13,1.56,1.47,2.47.14.36,0,.8-.48.89-1.11.22-2.2.7-3.36.12-2.4-1.2-4.55-.1-6.7.83-.41.18-.67.56-.55,1.05.15.58.62.89,1.15.81,1.28-.18,2.55.12,3.83-.04,1.82-.23,2.12.09,2.13,1.87,0,.6,0,1.19,0,1.79-.01,1.58-.61,2.32-2.15,2.38-1.45.06-2.89.13-4.33.29-1.06.12-2-.23-2.95-.66-2.11-.96-2.49-.83-3.79,1-.99,1.4-1.77,1.49-2.97.3-1.02-1.02-2.15-1.78-3.64-1.96-1.1-.13-1.86-.64-1.98-1.94-.11-1.2-.58-1.48-1.84-1.39-.55.04-1.12.12-1.66,0-1.58-.34-3.05-.01-4.47.67-.98.47-1.99.71-3.09.67-1.27-.05-2.44.27-3.52.96-1.01.64-1.66,1.47-1.71,2.68-.03.76-.33,1.32-.97,1.68-2.05,1.17-3.24,3.09-4.42,5.02-.6.97-.79,2-.36,3.06.51,1.25.42,2.42-.31,3.53-1.15,1.77-1,3.5.25,5.11,1.36,1.75,2.8,3.43,4.46,4.91.96.86,2.05,1.18,3.32.83.92-.25,1.87-.15,2.8-.16,1.46,0,2.88-.21,4.26-.74,1.33-.51,2.59-.4,3.74.5.55.44,1.2.61,1.87.78,1.94.48,2.75,1.75,2.33,3.71-.42,1.97.13,3.73,1.16,5.35,1.51,2.36,2.3,4.99,1.64,7.65-.57,2.31-.18,4.44-.03,6.67.18,2.76,1.47,5.15,2.13,7.73.08.33.25.65.49.89,1.02,1.01,1.47,2.2,1.53,3.66.06,1.4.75,1.75,2.12,1.78,2.24.04,4.07-.8,5.66-2.27,1.74-1.61,3.34-3.25,4.51-5.45.96-1.8,2.04-3.31,2.12-5.5.04-1.27,1.16-2.44,2.21-3.35,1.52-1.31,2.06-2.84,1.78-4.88-.33-2.36-.1-4.78.25-7.14.23-1.56,1.27-2.77,2.35-3.88,1.54-1.59,3.35-2.91,4.69-4.7.89-1.2,1.81-2.38,2.6-3.64.31-.5.74-1.06.26-1.63-.48-.57-1.13-.26-1.66-.04-1.37.57-2.78.73-4.25.69-.88-.02-1.5-.35-1.8-1.15-.56-1.51-1.65-2.57-2.88-3.51-.83-.63-1.27-1.46-1.37-2.49-.1-1.08-.44-2.09-.96-3.03-1.24-2.28-2.38-4.62-3.77-6.83-.23-.36-.51-.7-.6-1.12-.12-.55-.2-1.14.28-1.55.47-.4,1.03-.31,1.57-.07,1.07.48,2.02,1.03,2.27,2.35.17.88.68,1.65,1.16,2.41.87,1.36,1.84,2.67,2.33,4.25.14.45.43.84.79,1.15,1.35,1.2,2.11,2.74,2.62,4.43.38,1.26,1.22,1.66,2.48,1.19.48-.18.92-.45,1.35-.73.82-.53,1.59-1.22,2.5-1.54,2.48-.87,4.03-2.72,5.4-4.81.28-.42.5-.8.2-1.29-.6-.98-2.54-1.76-3.67-1.48-2.12.53-4.14-.42-5.05-2.4-.29-.63-.67-1.19-1.18-1.65-.66-.6-.75-1.34-.43-2.1.32-.76,1.05-.76,1.75-.77,1.21-.02,2.06.67,2.64,1.57.97,1.49,2.29,2.08,4,2.02.43-.02.87.03,1.2.34,1.23,1.17,2.72,1.24,4.31,1.12.67-.05,1.62-.35,1.79.84.31,2.57.37,5.14.52,7.71.02.29-.07.6.13.86v12.28c-.49,1.41-.39,2.9-.46,4.34-.14,2.95-.84,5.79-1.54,8.61-1.35,5.43-3.37,10.65-5.95,15.61-3.33,6.42-7.39,12.36-12.37,17.63-4.2,4.44-8.78,8.39-13.86,11.84-4.8,3.26-9.82,6.06-15.22,8.04-6.55,2.4-13.17,4.73-20.33,4.54-.54-.01-1.14.05-1.68.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m292.78,24.52c3.54,2.34,5.66,5.93,8,9.28,6.54,9.34,10.88,19.62,12.69,30.92-3.24.91-5.82-1.71-8.94-1.69-1.19.01-1.72-1.37-2.42-2.28-.71-.91-1.75-1.75-2.83-.88-1.25,1.01.37,1.43.71,2.16,1.39,3.01,3.15,4.71,6.43,2.27.95,1.43,2.64,1.95,3.79,3,.73.67-1.1,1.33-1.48,2.13-1.97,4.14-6.47,4.79-9.71,7.16-1.2.88-2.62.18-2.75-.98-.4-3.64-3.47-5.68-4.88-8.74-.93-2.01-1.32-4.83-3.96-5.86-.3-.12-.6-.25-.89-.38,0,.39-.16.91.03,1.17,3.74,5.18,4.95,11.81,9.41,16.55,1.55,1.65,3.38.43,5.11.08,1.01-.2,2.12-1.51,3.03-.37.94,1.17-.3,2.22-.9,3.18-1.66,2.65-3.56,5.14-6.05,7.05-4.12,3.15-3.99,7.54-3.59,11.97.17,1.93.02,3.55-1.62,4.79-2.26,1.71-1.78,4.64-2.85,6.63-1.79,3.33-4.1,6.6-7.37,9.02-2.07,1.53-4.34,1.18-6.5,1.74-.27.07-.91-.34-.99-.63-1.53-5.9-5.04-11.26-5.06-17.57,0-2.9,1.56-5.78-.06-8.7-1.56-2.81-2.89-5.59-2.26-9.08.28-1.56-5.25-3.68-7.21-2.97-6.75,2.45-12.45.36-15.96-5.89-.88-1.56-1.01-3.17.06-4.71.8-1.15.74-2.23.39-3.6-.86-3.31,1.56-5.37,3.54-7.39,1.1-1.12,2.41-1.8,2.42-3.72,0-1.21,1.45-2.05,2.44-2.18,3.7-.48,7.11-2.29,10.97-2.14,2.13.08,3.98-.83,4.61,2.65.22,1.21,4.18,1.66,5.88,3.48.01.01.87-.5.97-.86.8-3,2.67-2.13,4.45-1.23,2.53,1.28,5.16.62,7.62.2,1.93-.33,1.02-2.43.96-3.74-.05-1.23-1.22-.52-1.87-.75-1.77-.63-3.99,1.61-5.36-.78-1.94-3.39,1.72-2.74,2.83-3.21,1.93-.81,4.22-1.16,6.34.15.34.21,1.68-.36,1.69-.6.05-1.01-.58-1.69-1.49-2.3-.74-.5-4.04-.69-.79-2.59.14-.08.21-.5.13-.66-.07-.13-.51-.24-.64-.15-.7.5-1.5.97-1.95,1.65-.26.39.12,1.24-.76,1.31-.88.07-.99-.61-1.1-1.27-.11-.59-.53-.98-1.09-.78-1.36.47-2.32,1.79-2.12,2.91.48,2.62-.44,2.94-2.68,2.51-.81-.15-2.81-.24-1.11,1.74.54.62.5,1.58-.04,2.27-.19.24-.77.31-1.13.24-.87-.16-.53-1.06-.78-1.48-1.57-2.64-2.7-5.81-6.3-6.49-.19-.04-.41.15-.62.23.29.5.54,1.04.89,1.5,1.02,1.32,3.65,1.16,3.38,3.7-.05.51.09,1.13-.58,1.23-.69.1-.8-.49-.86-1.02-.13-1.19-.59-1.94-1.98-1.68-.28.05-.85-.15-.89-.32-.88-4.2-4.07-2.91-6.14-2.01-1.96.86-3.8,2.62-4.82,4.78-.98,2.07-2.92,1.67-4.37,1.37-1.43-.3-3.22-1.16-2.13-3.46.26-.54.18-1.24.28-1.86.09-.51.07-1.24.38-1.44.33-.22,1.04-.04,1.5.16,1.2.52,2.29.3,3.16-.55.68-.67.33-1.57-.29-2.03-2.8-2.09-.69-2.43.99-2.99.6-.2,1.16-.5,1.74-.75,0,0-.02.01-.02.01.56-.28,1.28-.42,1.66-.86,3.08-3.55,7.39-2.62,11.27-3.07,1.4-.16,1.97-.25,2.62-1.74.82-1.88,2.92-2.7,5.04-2.99.27-.04.51-.31.76-.48-.29-.1-.58-.26-.88-.28-2.45-.16-6.81,1.61-3.85-3.9.17-.32-.1-.91-.41-.6-1.27,1.26-3.96,1.74-2.64,4.55,1.08,2.3-1.32,2.81-2.32,3.82-1.06,1.07-1.48-.4-1.86-1.19-.51-1.06-1.44-1.06-2.39-1.05-1.44,0-2.53-.46-2.76-2.05-.22-1.55.87-2.03,2.06-2.25,2.82-.51,3.53-3.58,6.02-4.68,5.16-2.28,9.94-.17,14.84.7.12.02.31.58.22.68-.53.66-1.28.8-2.07.66-.72-.12-1.43-.76-2.15-.13-.12.1.07.7.26.96.61.83,1.32.45,2.2.43,2.06-.05,3.96.34,4.12-2.54.38.06.85,0,1.13.2,1.12.8,1.89.47,2.5-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m159.38,63.23c1.84-8.38,4.5-16.46,9.02-23.8,2.21-3.59,4.63-7.05,7.12-10.44,1.43-1.94,3.21-3.63,4.83-5.44,1.13.15,2.28.24,3.39.49.72.16,1.37.58,2.06.86.46.18.95.3,1.42.46.63.21,1.32.31,1.86.66.56.36.98.25,1.38-.09.95-.8,1.97-.74,3.12-.57,1.38.21,2.8.22,4.2.2.79,0,1.65-.35,1.8-1.17.15-.84.4-1.9-.79-2.43-.22-.1-.34-.44-.5-.67.27-.14.54-.31.82-.42.32-.11.66-.21.99-.24.27-.02.56.08.84.12-.3,1.22,1.4,1.56,1.18,2.84-.16.93,1.35,1.82,2.25,1.46.55-.22,1.08-.53,1.65-.66.66-.16,1.35-.05,1.52.75.16.78-.38,1.25-1.05,1.35-1.26.18-2.54.27-3.81.33-.95.05-1.92-.04-2.32,1.12-.01.04-.05.08-.08.1-1.4.7-2.79,1.41-4.19,2.1-.83.4-1.76.65-2.5,1.17-1.39.96-1.3,2.83.15,3.73.79.49,1.67.85,2.54,1.18.92.35,1.42.9,1.25,1.93-.04.25-.09.54,0,.76.13.32.33.72.6.84.2.09.74-.13.85-.35.61-1.29,1.71-1.91,2.93-2.49,1.25-.6,1.9-1.78,2.47-3,.36-.77.72-1.56,1.22-2.23.9-1.19,2.99-1.68,4.3-1.01.38.19.68.62.9,1,.84,1.51,1.28,1.6,2.66.6.37-.27,1.02-.61,1.31-.46.67.34.22.97.02,1.45-.21.51-.34.96.2,1.36.63.46.57,1.04.32,1.71-.45,1.23-.17,1.56,1.11,1.43.25-.02.51-.09.76-.08.81.05,1.03.5.52,1.2-.89,1.24-2.21,1.65-3.67,1.77-2.16.17-4.33.33-6.48.59-.65.08-1.3.4-1.88.74-.22.13-.22.64-.32.97.31.03.64.14.93.06.32-.08.59-.34.89-.49.68-.33,1.28-.34,1.47.55.24,1.09,1.02,1.33,1.98,1.46.38.05.73.4,1.09.62-.29.27-.53.69-.87.8-1.53.47-3,1.05-4.72.55-1.3-.37-2.55.35-3.66,1.15-1.95,1.41-3.94,2.77-5.91,4.15-.69.49-1.24.98-1.5,1.92-.56,2.02-1.59,3.72-3.88,4.34-1.48.41-1.63.81-1.65,2.33-.02.94.03,1.88-.11,2.8-.06.38-.51.7-.78,1.05-.21-.36-.55-.7-.62-1.09-.36-1.85-1.99-3.42-3.85-3.53-.48-.03-1.07.08-1.44.35-.88.65-1.79.79-2.78.48-2.85-.91-5.66,1.51-6.06,4.13-.24,1.55-.68,3.06-.03,4.65.54,1.33,1.64,1.66,2.83,1.87,1.12.2,2.11-.08,2.76-1.15.21-.35.51-.84.83-.89.58-.08,1.29-.03,1.76.26.21.13.04.97-.03,1.47-.03.24-.25.44-.36.67-.7,1.39-.68,2.39,1.25,2.51,1.49.09,1.95.82,1.55,2.33-.67,2.52.59,3.56,3.02,3.57.65,0,1.35.06,1.92.32.78.36,1.33.09,1.85-.38.66-.6,1.25-1.29,1.93-1.86.32-.27.8-.35,1.21-.52.09.42.21.84.25,1.27.02.24-.19.53-.12.74.11.32.37.58.57.87.22-.26.48-.49.64-.78.09-.16.02-.42.03-.63.12-1.45,1.07-1.71,2.03-1.03,1.22.86,2.48,1.18,3.92,1.28.66.04,1.4.43,1.9.89,1.22,1.13,2.6,1.92,4.15,2.45,1.57.54,2.92,1.42,3.9,2.78.86,1.2,1.4,2.46.44,3.89-.14.2-.07.54-.09.82.31-.04.65,0,.91-.14.75-.38,1.55-1.06,1.47.61,0,.1.47.32.71.3.37-.03.72-.25,1.1-.33.77-.15,1.41-.06,1.79.8.13.29.71.68.89.6,2.18-.98,3.65.38,4.98,1.64.89.84,1.6,1.4,2.86,1.07.36-.09,1.13.17,1.19.4.14.56.17,1.31-.1,1.79-.93,1.65-2.05,3.19-3.01,4.82-.36.62-.58,1.38-.67,2.1-.23,1.68-.29,3.39-.54,5.07-.24,1.57-1.22,2.48-2.85,2.63-.34.03-.67.14-1,.2-1.77.34-2.91,1.13-2.54,3.2.11.62.08,1.3-.06,1.91-.11.5-.39,1.03-.73,1.42-.78.89-1.66,1.69-2.49,2.53-.78.8-1.52,1.59-2.85,1.29-.89-.2-1.03.38-.7,1.09.18.38.45.73.63,1.11.52,1.14.15,1.99-1.03,2.25-1.02.22-1.54.88-2.28,1.46-1.2.94-.88,1.9-1.12,3-.32,1.52-.12,2.72.55,4.01.18.35.06.9-.02,1.34-.19.98-.5,1.95-.65,2.93-.17,1.17-.77,1.55-1.74.95-.62-.39-1.11-1.02-1.58-1.61-.82-1.02-1.62-2.07-2.35-3.16-.25-.37-.52-.96-.4-1.33.59-1.82.33-3.5-.56-5.12-.87-1.57-1.18-3.26-1.27-5.03-.15-3.06-.34-6.12-.57-9.17-.05-.67-.38-1.31-.49-1.98-.19-1.13-.4-2.26-.46-3.4-.11-2.05-.87-3.62-2.62-4.84-1.23-.86-2.31-2.01-3.24-3.2-1.35-1.75-2.52-3.65-3.74-5.5-.67-1.02-1.11-2.1-.65-3.38.13-.36.06-.86-.06-1.24-.45-1.36-.14-2.5.82-3.53,1.29-1.37,1.94-2.98,1.78-4.89-.12-1.42-.51-2.28-2.25-1.72-2.31.74-3.78-.71-5.11-2.29-.57-.68-1-1.52-1.66-2.09-.64-.56-1.5-.88-2.26-1.29-.55-.29-1.24-.44-1.63-.87-.86-.95-1.86-1.2-3-.92-1.29.32-2.33-.11-3.35-.82-1.66-1.17-3.08-2.42-3.49-4.62-.2-1.06-.95-2.07-1.62-2.98-1.12-1.52-2.21-3.02-2.28-5.01-.02-.53-.16-1.12-.85-1.02-.73.1-.6.69-.47,1.21.02.08.03.17.07.25,1.06,2.19-.13,2.73-2.02,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m230.9,14.76c1.22.16,2.36.26,3.49.47,1.3.23,2.49.18,3.69-.52.66-.39,1.53-.5,2.32-.59,1.82-.21,3.64-.35,5.46-.46.67-.04,1.36.02,2.02.16,1.45.31,2.89.68,4.32,1.06.3.08.55.33.82.5-.22.27-.38.67-.66.79-1.51.63-2.42,1.77-3.12,3.21-.82,1.68-1.68,1.97-3.54,1.54-.29-.07-.64.14-.97.22.26.22.49.48.78.65.21.12.56.04.73.19.33.28.79.65.8,1,.01.33-.41.86-.76.98-.75.27-1.57.41-2.37.48-2.23.22-4.31.79-6.27,1.94-.92.54-2.07.75-3.14.98-1.64.35-2.93,1.09-3.68,2.66-.48,1-1.08,1.82-2.44,1.61-1.36-.21-2.12-.84-2.66-2.18-.81-2-.36-3.49,1.06-4.95.97-.99.92-3,.06-4.32-.77-1.19-1.53-1.38-3.22-1.04-.95.19-1.94.25-2.91.25-.34,0-.67-.38-1.01-.59.25-.35.48-.73.77-1.04.13-.14.39-.14.6-.2,2.39-.76,4.77-1.55,7.17-2.26.88-.26,1.82-.34,2.69-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m216.87,27.12c-1.06-.24-1.57-.01-1.32,1.22.07.36-.51,1.2-.59,1.17-1.15-.37-1.81,2.55-3.09.5-.71-1.14-3.12-1.04-2.66-2.45.46-1.41,2.42-1.11,3.87-1.04.28.01.7-.34.83-.63.09-.2-.14-.62-.32-.87-1.7-2.31-4.2-1.95-6.58-1.91-.72.01-1.51.1-1.63-.75-.1-.79.64-1.09,1.32-1.04,3.23.23,6.58-.12,9.53,1.64,1.24.74,1.96,2.05,2.22,3.38.16.78-.93.74-1.59.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m303.79,102.97c-2.11,3.01-3.39,6.37-4.54,9.81-.24.71-1.35.57-2.04.05-.85-.64-1.62-1.45-1.24-2.57,1.07-3.14,1.53-6.64,4.92-8.47.58-.31,1.04-1.14,1.73-.7.48.3.68,1.06,1.17,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m214.35,19.09c-.65-.18-1.3-.08-1.6-.78-.29-.67-.01-2.25.49-2.51.76-.38,1-.7.23-1.36-.26-.22-.46-.81-.35-1.09.12-.3.63-.56,1-.61.53-.07,1.12-.02,1.64.14,2.89.91,5.85,1.01,8.84.94.55-.01,1.1.25,1.64.38-.48.35-.91.89-1.44,1.01-2.43.55-4.68,1.46-6.87,2.65-1.09.6-2.38.83-3.59,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m193.13,24.33c-1.45-.28-2.99-.35-4.5.37-.33.16-1.11-.07-1.32-.37-.37-.53.25-.75.65-.98.18-.11.29-.34.43-.52-.57-.19-1.15-.39-1.72-.58-1.02-.35-2.75,1.35-2.94-.22-.19-1.54,2.03-1.99,3.25-1.88,2.67.23,5.32.92,7.93,1.58.33.08.68,1.25.54,1.78-.3,1.08-1.41.64-2.31.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m259.44,40.94c-.89-.02-1.79.04-2.67-.09-.45-.06-.84-.46-1.26-.7,1.55-1.88.8-3.64-.16-5.46-.09-.17.69-.79,1.07-1.2.38.37,1.1.76,1.07,1.1-.12,1.55,1.24,2.9,1.85,3.17,2.81,1.22.69,2.15.08,3.19,0,0,.02-.01.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m187.64,66.36c2.41-.07,3.77,1.58,5.5,2.43.15.07.27.58.21.63-.24.19-.56.35-.86.4-2.59.41-4.22-3.01-7.03-1.77-.09-.22-.32-.51-.25-.63.59-1.09,1.74-.85,2.44-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m247.13,29.08c-1.05.02-1.87-.34-1.61-.91.9-1.99,3.06-.71,4.51-1.44.19-.1.69.4,1.04.62-1.15,1.31-2.8,1.36-3.94,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m215.77,44.04c-.82-.05-1.58-.28-1.5-1.19.08-.93.85-1.71,1.7-1.49.77.21,1.92,1.1,1.91,1.66-.02,1.02-1.32.82-2.1,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m253.04,39.42c-.76-.05-1.5-.18-1.35-.85.28-1.22,1.42-1.78,2.49-2.09.72-.21,1.16.54,1.07,1.24-.19,1.33-1.38,1.42-2.2,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m208.39,18.15c.88.38,2.12.91,3.36,1.44-.42.91-1.39.8-2,.7-1.09-.18-2.57-.01-3.01-1.38-.21-.64.66-.71,1.66-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m195.99,71.71c-.8-.39-2.45.47-2.33-.66.12-1.12,1.89-.89,2.99-.9.73,0,2.12-.33,2.01.64-.17,1.49-1.75.53-2.66.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m209.83,16.68c-.31-.19-1.2-.48-1.22-.82-.06-.88.84-.75,1.43-.75.57,0,1.47-.22,1.48.7,0,.76-.82.67-1.68.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m202.62,27.6c.99.3,2.05-.01,2.37,1.14.02.07-.44.43-.61.38-.97-.28-1.93-.63-2.88-.97.41-.2.82-.41,1.12-.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "m161.53,155.84c5.79,12.66,5.81,33.55,11.72,61.3-.95.85-.57,2.7-1.78,3.4-2.51-21.69-5.22-44.71-9.93-64.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m126.56,171.57c2.8-7.45-5.88,38.54-7.9,44.31,1.02-16.78,6.5-33.25,7.9-44.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m163.83,227.17c-5.17-.64-42.52,1.79-35.67-1.46,11.17,1.27,26.51-2.6,35.67,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m118.67,215.88c2.01-8.21,2.46-16.99,4.84-22.88-2.12,7.59-1.06,18.09-5.08,24.67.08-.6.16-1.2.24-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m118.43,217.66c1.96-4.23.09,7.95,5.93,7.74.86.05,1.91.56,1.59,1.77-5.14,0-8.41-4.52-7.52-9.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m163.83,227.17c.74-4.1,5.16,1.59,6.78-9.81,3.33,3.59-2.18,10.23-6.78,9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "m127.43,169.36c1.09-3.33,1.15-8.55,2.78-11.53.53.76-2.3,17-2.78,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m135.74,153.4c6.88.04,13.75.07,20.62.11-6.25.72-14.21.22-20.62-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m135.74,153.4c6.34.37,12.84-.09,19.18.27-5,.22-17.22.9-19.18-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m135.04,153.47c-2.78,1.41-3.76,1.36-4.8,4.02-1.2-1.9,2.55-4.21,4.8-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m155.42,153.67c1.87-.61,6.52.86,5.67,2.24-1.42-1.52-3.56-1.68-5.67-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m130.03,156.59c.42,1.15-.46,2.25-.51,3.53-.72,2.49.3-2.58.51-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m129.07,161.21c.2,1.05,0,2.11-.61,3.2.65-1.12-.25-2.18.61-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m129.07,161.21c-.26.55-.31,1.1-.3,1.66-.4-.64-.24-1.26.38-1.88.03.09,0,.16-.08.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m161.19,155.84c.41-.36.85.94.38,1.04-.47-.04-.88-.74-.38-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m127.71,167.94c.39.34.34.71-.1,1.1.09-.37.23-.75.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m162,156.83c3.8,17.16,6.89,35.4,8.65,54.43-3.91-18.43-6.11-36.57-8.65-54.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m167.4,191.06c1.01,7.78,3.38,17.88,3.98,26.69-1.75-.52-.97-2.31-1.53-3.64-.06-8.23-3.92-17.53-2.45-23.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "m162,156.83c1.95,8.75-.73,6.34-.24-.33.08.11.16.22.24.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m165.14,172.92c-.45-.81-.57-1.62-.39-2.4.13.79.26,1.59.39,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m164.15,165.75c-.05-.31-.1-.62-.15-.93.29.31.35.62.15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m127.43,169.36c-.17,11.8-3.62,28.46-7.86,44.71,2.28-15.56,5.74-30.16,7.86-44.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "m126.86,172.9c-.62,5.99-2.06,13.06-3.71,19.97,1.38-7.49,2.61-13.58,3.71-19.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.3,223.83c-12.18,6.68-29.41.86-43.31,2.76-4.75,1.19-10.72-9.11-5.08-9.56-.02,14.19,37.39.47,48.39,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.72,217.4c-2.54-13.08,6.66-35.88,6.88-46.13,1.74-4.78.45-12.82,4.05-14.82-3.63,20.14-5.86,41.21-10.93,60.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.39,156.36c-.31.22-.49.56-1.07.55.49-5.52,27.48-4.2,30.65-1.32,4.43,21.13,7.57,44.29,9.49,65.94-.89.42-.48,1.67-1.16,2.3-1.23-.63-3.34,2.08-3.43.11.58-2.16,3.01-3.04,2.45-5.76-2.41-17.92-3.73-34.14-6.83-51.1-1.65-4.25,1.21-12.16-5.2-12.4-7.98.43-18.06-2.36-24.9,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.62,223.4c-.12-.9-.36-1.86.83-1.87-.03.78-.34,1.38-.83,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "m163.65,170.95c-.79-5.18-1.5-9.87-2.15-14.15.49,4.21,2.81,10.16,2.15,14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m163.81,170.96c-.4-2.75-.83-5.26-1.15-7.82,1.27,1.96.96,6.35,1.62,8.82-1.02-9.7,2.09,13.4,3.12,19.1-2.39-5.68-2.37-14.35-3.59-20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m163.44,167.24c.06-.1.11-.2.17-.29.28.26.22.56.28.84-.41.11-.19-.41-.44-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.58,216.23c-3.31-7.6-2.69-17.34-3.94-25.59,1.33,7.54,2.94,16.86,3.94,25.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m170.56,214.43c-2.17-9.5-2.88-18.46-4.37-26.85,1.9,7.82,2.69,17.17,4.37,26.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "m120.72,217.4c.76-4.29,1.48-8.35,2.16-12.19,2.18-.35,10.28-10.06,8.92-4.41-3.09,2.5-.56,8.7-4.22,9.71-1.78.39-3.3,1.14-3.89,3.26-.22,3.17-2.07,12.57-2.97,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m167.99,222.18c-1.75,4.81-10.67-2.19-5.04-3.02,2.42.08,1.42-2.9,1.48-4.54-2.05-4.02-7.75.42-10.32-3.88-1.15-2.3,3.01-1.2,4.15-1.56,8.32-1.64,11.36,5.84,9.74,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m161.69,219.98c-.26.77.16,1.2.77,1.5,2.25,3.2-6.2-.36-7.32-1.1-3.1-.44-9.14,2.48-8.94-3.11.21-7.52,3.73,3.69,6.16-1.3.26-.94,1.47-1.66,2.08-.61,1.69,2.68,5.23,2.92,7.24,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m121.24,220.88c1.94-1.75,3.02.95,5.09.81,2.1.93,9.2-.7,8.27,2.44-4.34-.49-11.49,2.16-13.37-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m134.6,224.14c-.89-3.01,5.94-2,7.46-1.25-.24,2.73-5.39.63-7.46,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m160.17,222.46c.69.16,1.41-.17,2.09.35-6.73.02-13.46.05-20.2.07,3.69-2.68,13.13-1.16,18.11-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m126.51,184.37c.26-1.84,2.84-7.08,5-5.33-.66,1.45,4.06,1.3,3.16-.15.1-1.71,1.67-2.14-.85-2.76-.28-1.51,2.26-2.81.19-3.89.02-.68.84-.63,1.26-.89.37-.5.56-1.09,1.34-1.36.92.69,1.92.24,2.96.63.46,1.03-.33,2.34,1.53,2.28,3.29.48,3.26-1.45,2.3-3.44,1.31-2.56,5.01.23,4.12,2.56,1.87,2.33.15,3.56-1.72,5.36-1.64,1.52-2.01-.85-3.42-.97-4.17-1.02-2.22,2.94-3.71,4.65-1.63.81-3.15,1.84-4.74,2.75-1.39.33-3.67-.43-3.9,1.49-.24,3.11-3,.79-3.51-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m144.86,168.57c-.52.56-1.28.04-.83-.5,2.64-5.06-7.56-2.3-10.41-2.99-2.94,1.2.07,6.7-4.61,5.16.39-9.43,11.29-6.56,17.71-6.74.29,4.28,5.72,4.07,8.34,6.98.88,4.17-6.3-2.36-7.77-2.97-1.01-.46-1.15,1.25-2.43,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m131.39,156.36c.18-2.35,9.95-3.27,7.57-.83-.59.78-1.51-.35-2.39.35.37,2.31-3.6,2.62-3.33,5.12-.28,1.17-1.52,1.52-1.46.1-2.39.91-.22-3.41-.39-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m134.22,172.2c2,.36,1.54.04,1.2,1.69-.57.51-1.14-.24-1.88.2,2.59-.52.45,2.89-1.21,2.32-.98.16-1.17.49-.8,1.36-.96,1.86-3.76,3.37-4.82,5.67,1.09-3.53.1-7.77,3.22-10.11,1.55-.89.22-2.53,1.76-3.29.21.02.41.12.37.25-.23,1.28,1.6,1.27,2.17,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m130.59,161.25c2.55-1.79,1.67.26,1.68,1.94,2.6-.5,12.1-1.42,12.73.25-4.59,1.81-11.84-2.44-14.31,3-.01.94-.03.94-1.25,1.36.4-2.28.78-4.46,1.15-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m131.74,170.1c-.2,3.07-2.71,3.88-3.81,6.35.72-3.89.14-6.01,3.73-7.07.59-.03.47.59.08.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m126.51,184.37c1.45,2.19,2.37,5,2.98,7.47-5.17,3.08-3.75-4.68-2.98-7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "m130.36,199.52c-1.59,2.44-4.26,5.56-7.47,5.69-.26-3.26,4.79-6.71,7.47-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m130.15,199.45c-1.94.22-3.38,1.66-5.08,2.53-6.54,1.53,7.66-8.81,5.08-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m125.52,190.13c.52,1.14,1.41,1.92,2.92,2.06-3.41,4.83-4.33,2.59-2.92-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m124.64,195.1c1.04-.46,4.31-4.28,4.3-2.2.44,2.01-5.56,5.99-4.3,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m128.88,197.81c-3.59,3.78-7.89,2.11-2-1.03.96-.7,2.06.34,2,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m128.87,197.6c-1.9-1.25-2.95,1.02-4.85,1.16.3-2.78,7.38-6.26,4.85-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m128.55,194.64c-1.18,1.18-2.62,2.55-4.33,2.94.17-1.21,3.57-3.19,4.33-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m136.4,155.72c5.18-2.32,12.86-1.17,19.6-1.35,4.07-.94,7.01,5.75,2.8,5.57-2.55-1.71-9.04-2.13-11.54-.38.03,1.55-1.27,1.59-2.37.94-1.06-3.85-7.4-.56-10.2-2.11.36-.77,2.29-1.79,1.19-2.55.14-.1.28-.2.51-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m165.34,191.45c-.62,3.57,4.46,14.22.5,15.48-5.01-3.88-13.88-6.51-12.93-13.54.74-1.84,2.45-.26,3.7.06-.56,7.51,10.24,3.56,4.08-1.04-8.39-1.4,2.3-5.2,4.64-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m153.24,196.97c4.18,3.12,8.81,8.49,14.23,9.4,2.53,11.86-13.62-4.75-16.91-7.37-4-.95,1.12-2.08,2.69-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m152.26,170.47c2.49,1.18,4.63,3.61,7.71,2.06,3.66-.85,5.49,5.85.73,5.2-.98-3.3-6.2.57-5.93-2,1.27-2.31-3.14-3.68-2.51-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m161.89,167.11c1.5,3.82-2.22,3.09-4.82,2.57-.57-.89-2.33-.56-2.78-1.52-.29-.76-1.62-.16-2.14-.69,1.88-1.34,7.1-1.02,9.75-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m152.06,199.52c2.08,5.03,20.5,11.23,15.19,14.61-1.18-3.35-2.35-4.11-6.5-4.32-2.75-.89-16.03-11.91-8.69-10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m161.89,167.11c-.95-.14-3.84.38-2.95-1.24-.77-7.03,3.34-4.07,2.95,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m159.36,169.69c.92-.27,1.97.27,2.88-.05,1.74,5.19-3.33,4.37-2.88.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m164.32,184.11c.59,3.24,1.26,6.45-2.73,3.37-.84-1.34,1.62-3.12,2.73-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.25,176.74c-.09-.82-.19-1.62-.28-2.42,1.53,1.07,1.85,4.85,1.11,6.51-1.28-.74-1.38-2.92-.83-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m156.49,154.42c-7.13-.04-14.27-.05-21.4-.1,7.1-.17,14.31-.09,21.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m165.34,191.45c-1.32-1.09-5.56-1.2-4.92-3.11,1.46-.77,5.24,1.25,4.92,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m166.37,187.59c-1.38-5.62-1.8-11.75-2.72-16.64,1.17,4.66,1.64,10.62,2.72,16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m167.99,222.18c-1.9-1.25.29-3.22-.34-5.05,2.35.02,1.3,3.98.34,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m168.97,218.69c-.93-1.26-3.11-4.69-.45-4.82.16,1.57.81,3.21.45,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m158.57,159.32c.16.73.85.57,1.39.53,3.73.74-3.45,2.03-1.39-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m161.13,161.75c-.61-.05-2.7.64-2.31-.53.66-.29,2.35-.77,2.31.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "m161.05,161.13c-.66-.13-2.3.6-2.35-.33.59-.22,2.52-.69,2.35.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m164.32,184.11c-.67.43-2.99,3.27-2.93,1.35.39-.76,3.09-3.58,2.93-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m161.85,187.36c4.24,1.43,3.75,3.63-.07.68-.26-.18-.17-.49.07-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m160.87,159.94c-.6-.07-1.8.53-2.07-.15.61.11,2.02-.62,2.07.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m164.37,183.92c-.54-1.19-1.77-3.21-.64-4.32.49,1.35.72,2.88.64,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.08,189.59c0-.19.01-.39.02-.58,2.14.78-.39,2.12-.02.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m163.44,167.24c.78,1.58.62,3.56,1.06,5.39-.82-1.3-.61-3.8-1.06-5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m125.67,222.54c-4.52-.56-3.57-5.89-2.65-9.04.43-3.78,10.86-6.4,7.68-1.17-1.54,1.16-3.63-.46-4.7,1.5-.82,1.73-1.72,5.32,1.23,5.31,6.92-1.14,3.54,5.35-1.55,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m130.65,209.85c-.62-.03-1.24-.06-1.86-.09-.56-2.84,3.02-15.39,5.3-9.74-3.17,2.46,1.86,12.02-3.44,9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m132.13,199.04c-.76.58-2.52.67-3.07-.2,1.08-.19,2.72-1.37,3.07.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m123.02,213.49c-.26,1.58-.52,3.19-.78,4.84-.15-1.65.13-3.26.78-4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m147.87,215.31c-2.56-1.5-5.05-4.06-6.07-6.6-.73-.98-2.74-1.86-2.19-3.23,4.58-5.53,16.92.79,5.76,2.6.78,1.82,5.2.93,7.47,1.13,1.84.65,3.25,2.66,5.22,3.47.6,1.49,1.17,4.35.02,5.67-2.4.18-3.34-1.67-4.92-3.04-.44.31-.76,0-1.09-.28-1.55-1.68-2.66.2-4.21.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m148.38,207.1c3.32-4.36-6.09-2.13-6.88-6.53-.29-.84-.13-1.77-1.36-1.76-1.66-2.19,4.25-2.4,4.82-.53,2.53,3.91,8.41,7.24,10.16,11.52-2.24.14-6.94.52-6.75-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m155.12,209.8c-3.5-4.62-11.26-9.01-11.65-13.93,3.6-.09,5.59,5.37,8.73,7.44,1.93,2.23,10.33,7.24,2.91,6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m158.34,209.81c-2.26-1.76-22.98-21.68-11.29-14.03,3.63,5.03,8.38,9.96,13.7,14.04-.8,0-1.61,0-2.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "m158.09,218.35c-.48-1.9.51-4.91,2.49-2.41-1.14-2.03,3.08-2.57,2.4-.18,2.2-2.92,4.07,5.35.12,4.19-1.79-.06-4.3.63-5.01-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m165.33,217.12c-.4-1.06-3.64-3.53-4.24-2.7-.84,2.13-1.21.88-3.09,1.5-1.68-6.32,8.96-4.74,7.33,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "m155.81,222.45c-2.93-.92-20.79,2.75-15.78-2.66,2.8-.47,2.42-2.76,2.96-4.88,1.73-.2,2.67,1.13,3.77,2.21-.4,5.96,9.43-.11,9.05,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m147.87,215.31c1.37-2.54,3.99-2.25,5.3,0-.25,3.85-5.45,3.86-5.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m142.74,209.85c.47,1.23,1.74,1.51,2.65,2.23,1.66.69,2.17,4.86-.32,3.14-2.21-1.06-8.95-7.4-2.33-5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m155.81,222.45c-6.15-5.18,1.79-2.73,4.36,0-1.45,0-2.91,0-4.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m143.15,213.3c1.73.52,4.05,1.82,3.6,3.82-1.48-.31-4.99-2.02-3.6-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m139.68,222.45c.8.03,1.6.06,2.41.09-4.94.5-11.22.58-16.42,0,4.67.41,9.53-2.35,14.01-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m131.79,169.82c-.73-1.36-.36-2.36.31-3.61.1-2.39,3.9-.88,5.49-1.37,3.95.44,9.46-1.98,6.88,4-.44.73-3.19,1.37-2.5.05.4-.42,1.34-.95.99-1.59-1.92.06-9.19-1.51-8.78,1.19,1.56,1.32-1.51,1.4-2.38,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m133.94,183.44c1.56-1.61,9.63-6.09,8.59-1.65-2.22-.83-4.91,3.91-3.54,5.86,1.22.99,4.16.23,4.78-1.16,2.4,1.42,5.75,2.34,8.99,1.14,3.02-1.49,5.52.6,1.18,1.51-4.26.78-8.57,1.7-13,.99-7.04-.92-6.19-.27-7-6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m147.29,188.14c-4.08,1.92-2.52-4.54-5.94-4.21-.67-.03-1.51.25-1.91-.48-.23-1.11,1.79-2.74,2.7-1.81.83-.39.22-.81.08-1.21.49-.65,1.59-.87,1.47-1.86-.2-1.47,2.35-1.15,2.75-2.41.76-1.94,4.56-3.27,3.6-.03-2.51.33-2.83.81-2.8,3.45-.87,1.17-.87,1.63.38,2.67,1.1,1.09-.24,2.23-.12,3.45-.11.8.57,1.66-.21,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m134.37,169.38c-4.96-3.59,9.74-3.27,9.21-1.57-1.28,1.81-3.62,2.53-5.6,3.12-1.15.57-1.1-.07-1.34-.81-.7-.33-1.72-.19-2.26-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m139.3,170.72c.75-2.46,6.56-1.66,5.01,1.7-1.02,1.81-6.39,1.37-5.01-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m144.24,177.5c.69,3.37-2.77,3.26-5.22,2.68-1.97-3.44,3.22-4.51,5.22-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m133.94,183.44c2.12.4,1.03,3.19.6,4.65-.83,1.45-3.03.59-4.42.71-2.63-.43-.48-2.55-.57-4.08.36-1.91,2.97-1.09,4.39-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m151.25,169.58c3.42,3.04.09,5.08-3.49,3.73-2.09-3.29.17-4.69,3.49-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m134.37,169.38c2.6-.33,2.22.97,1.25,2.67-.21-.28-.38-.48-.92-.29-1.17-1.15-1.29-.74-2.46.15-1.49-1.88.3-2.85,2.13-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m129.05,186.7c-.08,2.12,2.79,2.18,3.33,4.14-.41,5.84-5.74-4.15-5.7-6.27.78.7,1.57,1.41,2.36,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m147.76,173.31c8.43-1.63,3.58,7.07,1.93,1.31.12-.9-1.81-.32-1.93-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m135.21,177.81c.89,2.36-4.93,2.33-3.34.82-.97.72-.54-.71-.52-1.27.21-1.02,4.94-1.07,3.86.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m147.74,169.57c-1.12.63-1.94-.55-2.88-1.01,1.04-2.9,6.58.74,2.88,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m135.21,177.81c-.22-1.18-3.27-.83-3.98-.19-2.79-2.37,7.55-2.24,3.98.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m143.82,177.17c-1.21.12-6.98.14-3.58-1.15,1,.13,4.38-.62,3.58,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m131.49,179.14c1.07.4,4.1-.88,3.98.68-.73,1.33-7.24.44-3.98-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m132.23,171.9c-.42-1.54,2.86-2,2.48-.37-.07,1.02-1.9.78-2.48.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m143.56,174.15c-.84.29-3.15.42-3.79-.1.86-.38,2.88-.35,3.79.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m134.56,174.37c-.69-.47-1.67.29-2.41-.13q.54-.43,3.27-.35c.91.46-.55.3-.86.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m148.15,173.79c.98.22,2.07-.07,3.09.37-.94.44-2.6.5-3.09-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "m134.91,171.73c-.07-1.36,1.3-1.02.7.31-.23-.1-.47-.21-.7-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m131.49,179.14c-.76.05-.42-1.88.25-1.98-.91,2.11-.06.9,1.14,1.14-.62.16-1.07.44-1.4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m131.82,181.19c.73-.4,1.22.16,1.82-.14-.65.57-.79.58-1.82.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m143.69,169.55c-1.17,0-2.35,0-3.52,0,1.07-.18,2.62-.29,3.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m159.38,166.15c-2.81,1.47-9.94,1.79-12.61-.18-.6-3.16,1.75-.69,3.26-.88,1.91-.09,9-.93,9.36,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m152.29,167.08c7.23,5.28-.32,2.76-2.84,0,.94-.15,1.89-.14,2.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m144.99,163.44c-.63-1.45.28-2.25,1.78-1.54.68,1.49-.47,1.9-1.78,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m148.72,169.42c.18-1.02-1.69-1.58-2.49-2.1,1.03-1.21,5.86,2.76,2.49,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m152.29,167.08c-1.46-.07-2.98.14-4.39-.16,3.48.01,6.96.02,10.44.04-1.97.29-4.04.04-6.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m146.6,163.59c.01-1.65-.36-2.64.21-4.22,1.23,1.86,0,4.48-.05,6.59-.31-.79-.04-1.59-.17-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m136.4,164.97c-.8.29-2.57.2-2.93-.15,1.04-.24,2.02-.22,2.93.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m154.74,170.33c.63-1.29,2.03,1.4.88,1.98-1.12.33-.69-1.34-.88-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m148.72,169.42c.84.05,1.73-.1,2.53.16-1.17,0-2.34,0-3.51,0,.29-.16.65-.12.98-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m134.63,163.92c0,.33-.69.41-.68.06,0-.27.68-.36.68-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m152.18,172.57c-.04-.81-.08-1.61-.12-2.39.13.85,1.25,1.94.12,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m131.4,168.52c.21.26.27.55.25.86-.24-.25-.41-.52-.25-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m134.7,158.4c1.54.27,12.43-.8,9.37,1.26-1.45-.09-14.45.52-9.37-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m138.42,159.6c1.99-.75,4.55.32,6.5-.44,2.38,2.41-14.57,2.22-11.53-.17,1.21,1.09,3.54.09,5.03.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m137.46,160.55c1.49,1.05,8.43-.96,7.57,1.38-1.83.31-16.15,1.85-12.1-.91,1.63-.68,3.16,1.15,4.53-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m134.67,161.14c-.6.03-1.17-.06-1.74-.13-.49-1.73,4.19-.56,1.74.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m138.12,155.74c-.45-.45-.6.18-1.22-.11.1-.5,1.47-.58,1.22.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m136.4,155.72c-.39.24-.95-.06-.46-.46.32-.13.64.17.46.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m131.93,162.75c3.89-1.81,8.85-.08,13.09-.82-1.76,3.4-10.02-1.01-12.73,2.01-.74.99-.95-.59-.36-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m127.5,187.29c1.07.9,3.58,4,2.61,5.02-1.68-.33-1.92-3.57-2.61-5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "m129.18,191.8c.67.19.95.85.48,1.47-1.23.73-1.41-1.16-.48-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m142.74,209.85c-4.08-1.45-7.64-6.11-8.98-9.86-.45-2.53-3.54-1.53-4.89-2.4-.04-.79.04-2.26.99-1.1,1.63-.41,1.89-.99,3.72.76,2.64,3.97,7.29,8.69,9.16,12.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m130.32,197.88c.82.07,1.86-.53,2.4.43-.3.17-.47.43-.6.73-.52-.47-1.2-.5-1.91-.47.03-.23.07-.46.1-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m129.05,196.23c-.08.06-.16.13-.24.19-3.29-7.68,8.5.14,4.48,1.17-2.01-.39-2.85-4.79-4.23-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m146.85,160.48c-.52-3.41,5.75-2.09,7.69-1.47.52.32.04.48-.2.66-2.92,1.72,3.01,4.19,2.85,1.19-.02-1.23-1.77-1.19-2.52-1.8-.03-1.01,1.86-.53,2.57-.55,2.52.62,1.38,4.09,2.02,6.11-.36.68-2.83.2-3.38-.36-1.37,1.45-4.23-.63-5.99.12-5.65.48-2.75-5.39,1.44-4.73-1.33-.23-3.11,1.36-4.48.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.79,156.32c-4.05-1.98,6.82-2.43,7.41-.84-1.13,1.97-5.3.47-7.41.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m145.04,161.07c-9.02.66-9.09-1.06.01-.85-.02.39.53.55-.01.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m145.04,161.07c0-1.5,2.12-.23,1.59.86-.53,0-1.07,0-1.6,0,0-.29,0-.58,0-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m154.69,159.23c-2.06-.9-4.22-.82-6.63-.77,3.07-.18,6.11-.04,9.18.04-1.09-.07-2.19-.07-2.55.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "m157.55,155.41c.13.46-.38.4-.83.41-1.8-.16.03-.8.83-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m142.79,156.32c2.15.01,4.29.02,6.44.03-2.1.16-4.34.15-6.44-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m154.06,155.37c.38-.16.7-.16,1.09,0-.06.53-.93.48-1.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m153.26,155.81c-.27.04-.54.06-.81-.1,0-.44,1.35-.48.81.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m153.26,155.81c-.18-.39.21-.74.29-.28.01.13.08.31-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m157.55,155.41c-.55,0-1.09-.01-1.64-.02.53-.17,1.07-.19,1.64.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m160.61,188.59c.39,1.1-1.21.71-1.46,1.42-3.29,2.02.9,1.16,2.07,2.13-2.08.64-4.51-.15-5.45,2.33-2.24-2.66-6.6-1.29-9.89-2.33-3.31-2.22,9.46-.54,10.87-2.27-.48-1.98,2.51-2.28,3.86-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m152.3,192.26c1.63.71,1.04,3.2.94,4.7-1.16,1.55-6.48,1.68-6.4-.94-1.11-.99-.43-4.54,1.18-2.89-.92,2.61,3.45,4.21,3.96,1.48.09-.77-.32-1.79.32-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m156.58,192.74c.81-1.57,7.8-.53,5.32,1.21-2.61-2.65-5.89,1.7-5.32-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m162.38,193.83c-.02-.31-.03-.62-.05-.92.8,2.13,1.19,5.84-2.2,4.77-.25-.34-.01-.5.24-.62,1.56-.6,1.14-2.22,2.01-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m157.63,197.69c-1.27-.42-1.63-3.02-.55-3.01.48,1.73,4.64,3.55.55,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m159.27,199.36c-.85.05-1.85.3-1.67-.92.82.16,3.67.41,1.67.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m159.16,190c-.63-1.52,1.46-.72,1.89-.4-.46.58-1.29.16-1.89.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m160.48,198.65c.6.23,1.35-.28,1.91.44-.49,1.01-3.7,0-1.91-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m157.63,197.69c1.58-.19,2.9-.16,4.48-.01-1.46.35-2.95.33-4.48.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m156.91,194.69c-.13.07-.26.14-.39.21-.06-.74-.32-1.48.06-2.16-.26.76,1.35,1.41.33,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m160.48,198.65c-.16.2-.69.38.03.63-.37.31-.79.28-1.24.07.61-.23.33-1.23,1.21-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m149.58,199.31c-2.58-.37.39-1,1.22-.7,2.61.1,0,1.29-1.22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m149.58,199.31c.69-.15,2.24.36,2.21-.72.27.27.27.6.28.93-.8-.12-1.87.34-2.49-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m150.79,198.6c-.41.03-.82.29-1.22-.03.41-.04.82-.31,1.22.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m147.35,183.88c.7-1.17-.57-1.8-1.08-2.55-1.88-3.05,5.28-.06,6.29-2.49,2.37-1.41,6.73,4.12,7.99.03-.79-1.78,1.77-1.42,2.7-2.13,2.19,7.09-.89,7.64-7.14,7.54-1.32-.19-2.9,1.36-3.96.38-1.24-1.25-3.26.12-4.8-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m155.37,179.41c-6.19-.48-1.71-2.91-3.99-6.06,1.01-.31.95-1.32.91-2.14,3.45,1.03,3.51,5.57,3.08,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "m155.37,179.41c-1.76-3.79,4.5-4.79,5.36-1.85,1.62,3.44-4.11,3.95-5.36,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m154.91,172.11c2.39.06,3.16.66,4.29-1.41,3.33,2.7-3.81,3.98-4.29,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m155.92,173.88c1.19.34,2.31-.13,3.5.28-1.72.42-3.29.32-3.5-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m155.17,173.04c.66.21,1.38.06,2.03.32-.69-.06-1.43.19-2.03-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m159.3,170.8c-1.05-.19-4.85.69-4.16-1.16.83-.63,6.13-.1,4.16,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m155.47,169.59c-.66-.25-3.52-1.02-2.21-2.11,1.06.44,6.14,2.18,2.21,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m153.26,167.47c.14.89-1.3.33-1.82.23.32-.59,1.25-.08,1.82-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "m154.62,168.05c-.4-.13-.98-.08-1-.57.34.03,1.63.05,1,.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m155.47,169.59c1.13-.2,2.39-.22,3.53.02-1.18,0-2.36-.02-3.53-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m159.16,164.8c-.04-1.37-.53-2.75-.28-4.04.17,1.75.68,3.63.5,5.38-.05-.58-.92-.87-.22-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m159.3,170.8c.42-.16.32-.48.34-.76.31.67.6,1.6.06,2.14-.42-.48-.28-.94-.4-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m160.61,188.59c-1.22-.1-2.43.06-3.58.09-1.89-.62-1.34-2.87.69-1.99,1.24-.04,3.52-.41,4.13.68.33,1.64,3.13,1.35,3.31,2.84-1.6-.32-2.9-2.13-4.55-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m161.01,183.92c1.39-.19,1.81-1.41,3-1.82.89,2.05-2.37,2.55-2.29,4.29-2.75,1.19-4.19-2.33-.72-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m160.63,186.36c.44-.7,1.28-.01,1.16.62-.69.38-2.03.2-1.16-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m139.68,222.45c-16.59.71-5.5-.78-9.04-12.6,3.04.02,7.06-2.01,9.7.02-.03,1.28,1.15,1.53,1.78,2.26-3.41.48-6.94.82-5.94,5.71.65,2.86,3.68.57,5.1,2.13q-2.13.77-1.61,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m132.2,213.21c1.93,4.99-4.65,9.66-7.71,5.3.41-6.57.11-5.55,3.73-1.29-2.06-2.52,3.1-1.66,3.98-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m132.2,213.21c.03,3.49-1.93,2.17-4.25,2.98-.64.47-.68-.78-1.31-.33-5.59-2.29,4.16-6.11,5.56-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m136.85,209.78c-5.93,1.67-5.75-6.25-3.09-9.78,2.25,2.5,3.32,6.44,3.09,9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m139.96,197.89c0,.47.66.61.4,1.09.52.02,1.84-.93,1.77.1-.68,2.23,2.18,2.91,2.63,4.88-1.78-.63-3.65,1.72-5.01.31-5.28-4.42-10.13-14.98.2-6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m134.34,194.65c-.33,3.76,4.27,8.1,7.3,9.83-.43.7-.65,1.84-1.87,1.04-2.52-2.53-4.38-5.36-6.49-7.92,1.75-1.66-1.54-2.09-2.01-3.4-1.21-2.62,5.57-1.31,3.08.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m148.38,207.1c.6.99,1.76,1.53,2.19,2.71-4.96,1.16-10.62-3.41-2.19-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m143.84,205c1.42.65,2.81-.16,4.24.62-1.64.74-3.69.53-4.24-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "m138.2,197.65c-3.64-4.16.12-6.53,4.61-5.76,3.09,2.87-.39,7.46-4.61,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "m141.39,198.56c-.56.83-1.07.92-2.55.43.73-.56,1.69-.32,2.55-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "m138.2,197.65c1.5,0,3,0,4.5.01-1.44.36-3.09.36-4.5-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m143.45,196.98c.05-1.4.09-2.77.14-4.12.92.78.03,2.91-.14,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m143.79,194.22c-.97-4.66,4.41-1.61,3.05,1.81-1.29-.29-1.67-2.19-3.05-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m160.43,215.92c-.88-2.07,2.44-3.78,2.71-1.03.24.86.58,4.09-.99,2.73,2.17-2.97-1.54-4.44-1.29-.85.87,1.73-1.95,2.39-.92.62.63-.3.65-.84.5-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m162.58,214.74c.52.59.51,1.2.23,1.82-.08-.61-.16-1.22-.23-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m141.29,219.96c-5.75,1.5-7.3-3.99-4.1-7.61,6.58-2.18,8.08,4.8,4.1,7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.85,209.78c-.95-2.4-1.55-4.79-1.32-7.31,2.04,2.45,4.27,4.87,6.62,7.34-1.77.11-3.53.02-5.3-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m142.15,212.35c-1.65,0-3.3,0-4.96,0,1.52-.34,3.82-.58,4.96,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m135.32,166.13c-.2-.22-.76,0-.71-.41.16-.43,1.19-.12.71.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m136.86,166.05c.73-1.41,1.87.5,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m137.8,166.04c.02-.17.04-.34.05-.51.26.03.54.03.74.22-.29.08-.44.32-.79.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m136.86,166.04c-.44.15-.56.02-.49-.35.19.13.36.26.49.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m134.14,165.93c-.3.06-.46.02-.6-.08.25-.22.42-.22.6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.43,183.46c3.58-.73,6.02,1.32,4.02,4.75-.58.49-4.49.45-5.04-.04-.59-.91-.54-4.54,1.03-4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m157.23,188.54c.13.06.26.12.38.18-7.61,4.37-19.78,3.45-27.31.41,5.76-1.47,12.42,2.67,18.84,1.12,2.36-1.31,5.37-1.37,8.09-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m156.78,186.79c-2.17,1.44-5.87,1.77-4.08-1.95,1.75-2.28,9.05.5,4.08,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "m150.34,189.36c-2.18,3.23-12.93,1.27-16.74-.84,5.16.84,11.55,2.25,16.74.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m152.83,187.54c-1.36,2.59-8.24.5-5.1-2.14,2.77,5.37,5.29-3.97,5.1,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m157.23,188.54c-1.91.08-3.66,1.86-5.51.62,2.08.23,3.79-1.84,5.51-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m142.14,181.65c-.81-.17-1.58.17-2.27-.44,1.07-.4,1.9-.23,2.27.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m149.64,189.16c.4,1.31-1.47.25-2.06.6.06-.99,1.43-.27,2.06-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "m151.89,176.21c2.68,3.46-2.08,5.8-4.78,3.53-1.03-3.78,1.71-4.23,4.78-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m147.78,185.59c-1.96-.22.33-3.05,1.76-1.57-.5.58-.96,1.21-1.76,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m147.11,176.69c0,1,0,2.01,0,3.05-.06,0-.12,0-.18-.01.08-1.03-.19-2.05.18-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m149.59,174.44c.07,0,.13-.01.2-.02.01.48.02.96.04,1.45-.34-.46-.18-.96-.23-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m140.24,167.03c5.02-.4-.19,3.18-2.53,1.83-3.87-1.37.46-2.21,2.53-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m140.74,170.03c.7-.06,1.95-.47,2.23.19-.44.4-1.77.37-2.23-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "m142.41,170.92c.07.44-.18.72-.49,1.02.63-1.35-1.36-.88.49-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m131.39,184.6c.7.43,2.78,1.72,2.14,2.63-.79.54-4.17-2.57-2.14-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m131.93,188.55c1.81,1.01-2,1.12-1.79-.05.6.02,1.19.03,1.79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m130.52,187.33c-.22-.31-.18-.63.08-1.02.85.51,1.17,1.37-.08,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m133.82,184.55c.22.29.19.6-.05.98-.81-.49-1.18-1.3.05-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m130.52,187.33c.33-.05.69.01.98-.23-.21.66-.62.32-.98.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m133.82,184.55c-.31.05-.65,0-.93.23.18-.64.59-.28.93-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m150.29,170.16c3.22.29-.22,4.49-1.36,2.24,2.15-1.14.22-1.02,1.36-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m149.15,172.55c-1.18.68-2.28-1.79-.84-1.68.69.35.93,1.04.84,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m150.29,170.16c-.16,2.55-.8.96-1.99-.02.66-.06,1.32-.79,1.99.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m148.3,170.14c1.3.18,1.51.42,1.23,1.36-.56-.07-2.42-.68-1.23-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m131.59,189.72c4.75-1.22,9.33,8.76,2.62,3.23-.55-.46-1.96.04-1.95-.96.07-.92-1.57-1.44-.66-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m132.26,192c.96-.04,2.82,1.15,1.55,2.09-.84.33-2.75-1.73-1.55-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m131.01,194.19c-1.44.39-1.58-1.09-.87-2.16,1.45-.16,1.59,1.17.87,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m131.01,194.19c-.19-1.08.82-3.4,1.13-1.28-.8.19-.47,1.31-1.13,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m159.16,164.8c.04.31.07.62.11.93-2.59-.56-4.58-.49-7.28-.5-.95-.1-1.97-.28-3.07-.04-.85-.09-1.11-.88-2.1-.7,0-.39,0-.78,0-1.17.45.09,1.71.08,1.14.77,1.22.49,2.07-.61,3.26-.15,1.22-.16,4.96,1.64,4.24-.73,1.27,2.18,2.05.5,3.71,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.92,166.05c.69-.31,1.42-.17,2.15-.04-.68.31-1.41.25-2.15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m149.49,166.18c-1.86.33-1.68-.72.03-.18-.01.06-.02.12-.03.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.89,165.13c.37-.36,1.27-.31,1.65-.03-.2.27-1.9.33-1.65.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m154.1,166.2c-.43.02-.76.11-1.04-.11.57-.36.62-.35,1.04.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.1,164.76c.28.1.72.03.79.37-.3.19-1.45.07-.79-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m152,165.23c.15-.33.55-.32.93-.31.29.45-.68.32-.93.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m150.15,165.28c.21-.12.2-.24,0-.37.34-.01.68-.02.93.25-.25.21-.59.13-.92.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m151.06,165.16c-.22,0-.34-.08-.35-.24.52-.15,1.14.4.35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m147.92,165.15c.31-.1.62,0,.93,0,0,.04,0,.09,0,.13-.32,0-.65.02-.93-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "m152.91,165.19c-.07-.42.39-.29.41-.02-.12.13-.25.15-.41.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m152.77,165.99c-.1.11-.22.11-.29-.03.03-.14.27-.14.29.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m146.85,160.48c2.19-.06,3.77-1.4,6.03-.79-2.32-.2-4.06.74-6.04,1.27,0-.16,0-.32.01-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.58,170.63c2.43-1.32,6.08,1.93,1.35,1.8-1.3.35-1.6-.73-1.35-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m155.56,170.77c.04.5.08,1,.13,1.51-.41-.12-.27-1.12-.13-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m138.42,159.6c-.83.19-5.62.19-3.4-.43.88.36,3.1-.42,3.4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m137.46,160.55c.24.93-1.12,1.68-1.66.83-.85-.69,1.14-1.75,1.66-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m134.67,161.14c.21-.24.42-.48.63-.71-3.16-.3,3.07-.79-.94,1.18.1-.16.2-.31.31-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "m134.78,161.51c.34-.23.65-1.17,1.03-.85.17.78-.33.91-1.03.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m138.56,160.31c.3.59-.85.7-.81.12.23-.2.5-.25.81-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m134.29,160.28c.33.06.73-.03,1.01.15-.34-.03-.74.04-1.01-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m130.14,192.03c-.09.71-.18,1.43-.28,2.16-.38-.59-.71-2.31.28-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m133.52,197.85c2.2,2.38,4.36,5.04,6.25,7.67-2.66-2.09-4.59-4.88-6.25-7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m129.05,196.23c-.63-1.07,1.1-2.35,2.01-1.6,1.49,1.11-1.13,3.36-2.01,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m129.5,196.67c.61-.08,1.95,0,1.02.8-.62.4-1.72-.08-1.02-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m154.69,159.23c3.39-.43,4.06,3.33.87,3.4-2.07-.09-3.86-2.87-.87-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m150.16,191.03c2.01-.52,4.08-.87,5.94-1.68,2.92,1.38-4.34,2.55-5.94,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m146.86,193.14c-2.03-.81-3.65-.76-5.71-1.06-1.37-1.63,9.12-.77,5.71,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.12,192.93c.79-1.57,3.65-.74,5.18-.66.8,2.15-4.11,1.35-5.18.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m157.07,189.99c-.45-.06-.52-.59-.98-.64.3-.13.6-.26.91-.38-.08.82,1.14-.06,1.59.56-.28.69-1.04.27-1.52.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "m145.01,191.46c-5.64-.1-.62-.3,2.15-.22-.69.27-1.43.13-2.15.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m147.85,193.37c3.95-1.71,7.56,3.59,1.46,3.1-1.23.31-1.85-.36-1.61-1.58.91-1.16,2.56.76,3.15-.61-1.17-1.14-3.81,1.41-3-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "m147.87,194.73c-.02.51-.04,1.02-.06,1.53-.33-.91-.34-1.8-.02-2.69-.05.39.2.84.08,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m156.91,194.69c-.01-.98.79-2.47,1.91-1.85-.04.91-1.45,1.31-.87,2.44,2.03,3.06,4.88-.37,2.06-2.4,6.41,1.17-1.95,8.52-3.1,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m158.72,192.91c-.1-.06-.19-.13-.29-.19.62-.32,1.28-.32,1.96.01-.51.48-1.03.78-1.67.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m162.28,194.69c-.16-.36-.32-.71-.47-1.06.61.06.79.55.47,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "m158.22,185.05c-5.43-.14.37-2.69,2.78-1.14.71,1.52-2.08.53-2.78,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m152.68,185.43c-.44.12-.57.46-.77.77-3.43-2.98.85-3.71.77-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m150.23,184.03c1.83.06,2.33,3.34.6,3.01.91-1.53-1.01-3.34-2.05-1.48,1.38,4.81-3.53-1.8,1.45-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m152.43,181.34c-1.67.21-3.9.54-5.19,0,1.18-.59,3.66-.27,5.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m156.94,181.13c.88.09,1.67-.18,2.54.06-.52.7-1.99.69-2.54-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m152.48,179.57c-.04-.92-.08-1.82-.12-2.71.33.86.37,1.85.12,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "m160.23,178.91c-.6,1.86-4.94,1.5-3.68-.76-1.62-2.66,4.65-2.02,3.68.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "m156.71,177.7c1.53.35.15,1.18-.72,1.23-.59-.74-.18-2.21.72-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m158.73,176.55c-.53.26-1.09.35-1.67,0,.54-.25,1.09-.25,1.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m160.23,178.91c-.3-.46-.32-.91-.15-1.37.38.45.43.91.15,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "m156.71,177.7c-.33,0-.57-.15-.81-.32.22-.36.88-.06.81.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m155.99,178.93c.17-.14.36-.24.63-.21.15.41-.66.75-.63.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m159.88,179.44c-.06-.18-.37-.36-.13-.54.4-.15.64.42.13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m156.88,176.57c.08.12.43.22.19.37-.29.15-.55-.29-.19-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m158.22,185.05c.89-1.79.86,1.64,2.4,1.3.26.24-.12,1.6-.63.92-.37-.6-1.73-.64-2.19-.09-.74.76-.66-.33-1.03-.4.54-.55,1.5-.82,1.44-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m157.81,187.19c.27-.68.98-.32,1.51-.39-.5.13-1,.26-1.51.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m126.64,215.85c-.06-.68-.49-1.95.49-2.12,1.29.42-.25,3.59,2.15,3.13,3.18,1.53-1.32,2.17-2.64-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m134.29,192.68c1.49,1.08,3.8,1.52,3.03,3.78-1.58-.81-3.09-1.59-3.06-3.35-.15-.04-.12-.32.03-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m137.61,192.9c-1.38-.98-4.09-1.56-4.41-3.21,1.14-.68,3.4,1.2,4.8,1.53,1.59.53.16,1.04-.39,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m140.1,194.27c-1.03-1.48,3.46-1.92,2.45-.03-.82.23-1.65.38-2.45.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m140.1,194.27c.83-.33,1.65-.47,2.45-.03-1.05,1.32-1.54,1.33-2.45.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "m138.55,192.24c1.18-1.35,2.96-.04,4.41,0-1.47,0-2.94,0-4.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m141.51,218.36c-1.31,1.59-4.52,1.23-4-1.11,1.44-1.42,5.16-2.3,4,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "m136.78,214.71c.63-3.15,6.51-2.02,4.25-.19-1.37-.41-3.16,1.03-4.25.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m140.97,214.13c.27-.1.55-.2.82-.3,0,0-.01,0-.01,0,.66,1.16,1.27,4.54-.61,4.3.85-2.44-2.64-.8-1.67-2.5.88-.13.76-1.23,1.46-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m140.97,214.13c-.38,1.87-3.05,2.61-4.54,1.77,0-1.85,3.09-2.21,4.54-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m136.43,215.9c1.94-1.35,3.67.17,1.26,1.55.06.5.43.93.21,1.5-1.12-.64-1.62-1.66-1.48-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "m142.56,215.91c-.99-.36-.92-1.2-.77-2.07.67.49.84,1.22.77,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m140.2,185.37c.38.27.1.72.39,1.01-1.5,1.26-2.35-1.13-.39-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m142.87,185.95c-.13,1.2-.97.57-.9-.34.21.35.48.34.9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m141.16,185.13c.66.57-.37,1.13.24,1.57-.51-.43-.46-.93-.24-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "m140.2,185.37c-.29.21-.62.17-.95.17.31-.11.57-.47.95-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m141.22,192.02c-1.59.06-3.81.2-4.57-1.48,1.68.48,3.76.46,5.32.87-.43.02-.86.05-.74.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m152.68,185.43c0-.13.01-.27.02-.4.36.82.39,1.66.12,2.51-.05-.71-.1-1.41-.15-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m151.32,185.03c1.04,1.46-.75,2.15-1.71,2.71-2.62-1.29-.64-4.23,1.71-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m149.61,187.75c-.15-.62-.43-1.92.7-1.4.22.52.2,1.94-.7,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m150.33,187.57c0-.41-.02-.82-.02-1.22.21.4.36.62.9.81-.22.25-.58.28-.88.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m148.48,179.28c-.07.37-.88.42-.8-.03.02-.4.83-.41.8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m148.46,177.2c-.07.35-.81.31-.74-.08.04-.35.77-.29.74.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "m148.48,178.15c.05.37-.67.44-.76.11-.13-.43.68-.49.76-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m139.89,167.71c-1.09.13-2.17.24-3.17-.12,1.08-.11,2.16-.25,3.17.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "m149.32,171.06c.04.15.01.33.21.44,0,0-.01.02-.01.02.95.33-.09.91-.58.43-.45-.62-.52-.78.38-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m150.56,171.34c.69.33.27.76-.33.59-.49-.28-.09-.61.33-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "m149.74,172.11c-.05-.62.34-.44.63-.15.04.44-.41.58-.63.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "m148.95,171.95c.68-.22.65.3.2.6-.21-.18-.2-.39-.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m149.92,171.35c0-.21.09-.37.38-.44-.07.19.08.32.27.43-.21.07-.43.16-.64.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m149.32,171.06c-.69.15-.29.57-.36.87-1.05.14-.21-.55-.82-.88.39-.2.78-.21,1.18.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m149.92,171.35c.18,0,.35.01.53.02-.19.16-.16.37-.17.56-.26-.14-.51-.27-.76-.43.13-.05.27-.11.4-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m134.29,192.68c-.03,1.01-1.19-.04-1.11-.61.52,0,.76.38,1.11.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m158.04,171.83c-.35.27-.76.17-1.17.02-.95-1.17,1.81-1.16,1.17-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m158.04,171.83c.02-.36-.19-.65-.53-.91.86.11.82.47.53.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "m156.83,171.07c.01.26.03.52.04.78-.44-.27-.51-.54-.04-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m137.19,160.91c-.12.28-.16.6-.68.58-1.3-.31.55-1.94.68-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m130.28,194.85c.44.23.38.67.51,1.11-.4,0-.76,0-1.14,0,.05-.45.23-.82.64-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m157.43,160.76c.11,1.94-4.06,1.77-4.14.02-.23-1.87,4.13-1.66,4.14-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m152.11,193.34c-1.35,0-2.71,0-4.06-.01,1.35-.3,2.7-.3,4.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m148.03,194.44c.05-1.48,2.2-.65,3.18-.86,2.83,1.08-2.13,1.65-3.18.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m148.03,194.44c1.37.01,2.74.02,4.11.04-1.04.88-3.49.87-4.29-.04.06,0,.12,0,.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m160.49,196.92c-2.75,1.09-3.92-3.65-1.61-2.67-.2.52.6,1.41,1.06.81.37-1.13-1.23-.61-1.26-1.46,2.8-1.2,4.18,1.49,1.81,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m161.16,193.61c-.61.56-1.56-.75-2.36-.04.87.95-1.18.03-.88,1.16-.02.24.09.52-.24.64-1.74-1.5,2.27-3.63,3.48-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m161.31,195.17c1.15.41-.32,2.1-1.04,1.56.21-.61,1.03-.83,1.04-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m148.47,185.6c-.32-1.3,1.93-1.75,2.85-.56-1.25-.36-1.98-.36-2.85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m157.41,178.39c-.06-.16-.12-.33-.18-.49.28.08.56.15.84.23-.1.36-.41.25-.66.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m158.83,185.64c.19.26.34.47.11.66-.47.23-.65-.47-.11-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m137.7,217.45c.46-.6,1.62-2.6,1.79-.93-.59.31-1.11.83-1.79.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "m139.53,215.89c.1-.92.96-.99,1.42-1.49-.07.93-.44,1.55-1.42,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m148.92,185.03c.78-.9,2.86-.15,2.19,1.08-.34-1.77-1.5-.73-2.19-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m149.99,185.97c-.56.07-.66-.68-.12-.72.51-.07.64.67.12.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "m148.92,185.03c.3.35-.16.92.17,1.55-.83-.45-.69-1.05-.17-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m154.12,160.48c-.16-1.5,3.71-.78,2.32.63-.73-.16-2.24.37-2.32-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m154.33,160.98c.41.07.85.03.53-.44,2.73.02-.47,2.2-.53.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m154.66,161.61c.53-.13,1.07-.77,1.55-.23-.54.71-.82.75-1.55.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m155.55,161.26c-.05-.02-.11-.02-.16-.02.15-.34.72-.33,1.05-.13-.05.08-.09.17-.14.25-.23-.14-.52.05-.75-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m155.55,161.26c.25.03.53-.08.75.1-.27.03-.56.16-.75-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m154.33,160.98c0,.09-.02.17-.03.26-.22-.24-.2-.5-.19-.76.19.14.16.33.21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "m157.69,195.37c-.22-.49.41-2.44.83-1.34-.83.67-.12,1.42.17,2.17-.65-.04-.69-.56-1-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m158.8,193.57c.7-.95,2.62.03,2.32,1.02-.57-.86-1.38-1.1-2.32-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m158.58,194.03c1.41-.76,3.1,1.94.6,1.57h.02c-.49-.42-.4-1.04-.62-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m161.31,195.17c.14,1.13-1.25,2.09-2.23,1.22,1.17.04,1.79-.48,2.23-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m158.61,194.28c.94.21.62.81.59,1.33-1-.2-.8-.77-.59-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m159.18,195.6c.42-.28.83-.58,1.43-.46-.19.77-.53,1.21-1.43.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "m160.57,194.73c-.68.02-1.28-.07-1.28-.9.63.03,1.15.22,1.28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m155,160.87c.41.41-.49.45-.56.11.14-.13.35-.11.56-.11Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther1);
export default __webpack_public_path__ + "static/media/other1.ac78c60e89ee00b58e04c54711e0ae2f.svg";
export { ForwardRef as ReactComponent };